import { useEffect, useState } from "react"
import { CommentaryScreenNew } from "./CommentaryNew.jsx"
import _, { isEmpty, isEqual } from "lodash"
import { ALL, BALL_BYE, BALL_LEG_BYE, BALL_START_STATUS, BALL_TYPE_BOWLER_RETIRED_HURT, BALL_TYPE_BYE, BALL_TYPE_LEG_BYE, BALL_TYPE_NO_BALL, BALL_TYPE_NO_BALL_BYE, BALL_TYPE_NO_BALL_LEG_BYE, BALL_TYPE_OVER_COMPLETE, BALL_TYPE_PANELTY_RUN, BALL_TYPE_REGULAR, BALL_TYPE_RETIRED_HURT, BALL_TYPE_WIDE, BALL_WIDE, BAT, BATTING_TEAM, BOWLING_TEAM, CHANGE_BOWLER, CURRENT_BOWLER, LIST_TO_EXCLUDE_WICKET_FOR_BOWLER, NON_STRIKE, NO_BALL, NO_BALL_BYE, NO_BALL_LEG_BYE, ON_STRIKE, OVER, PLAYER_LIST, PREV_NON_STRIKE, PREV_ON_STRIKE, RETIRED_HURT, RETIRED_HURT_BATTER, RETIRED_OUT, RUN, SCORING_STATUS, SWITCH_BOWLER, TIMED_OUT, WICKET } from "./CommentartConst.js"
import SelectPlayerModal from "./CommentaryModels/SelectPlayerModal.jsx"
import ExtrasModal from "./CommentaryModels/ExtrasModal.jsx"
import ChangeOverModal from "./CommentaryModels/ChangeOverModal.jsx"
import WicketModal from "./CommentaryModels/WicketModal.jsx"
import { extractRequiredFieldsForTeamStatus, fetchNextPlayerOrder, fetchWinnerMessage, fetchWinnerMessageRmk, generateBall, generateDisplayStatus, generateOver, generatePartnership, generateRemainingRuns, generateWicket, getBallsForAllOver, getBowlerOnlyRuns, getBowlerRelatedWickets, getEconomyRate, getNonNegativeValue, getPlayerNameById, getRequiredRunRate, getRunRate, getStrikeRate } from "./functions.js"
import { useDispatch, useSelector } from "react-redux"
import { addCommentaryScreenData, addSuperOverCall, changeBowlerFromCommentary, clearAddCommentaryScreenData, clearLoadingAndError, clearUndoFlag, updateCommentaryBallStatus, updateCommentaryDisplayStatus } from "../../Features/Tabs/commentarySlice.js"
import ChangeInningsModal from "./CommentaryModels/ChangeInningsModal.jsx"
import { useNavigate } from "react-router-dom"
import UpdateInningsModal from "./CommentaryModels/UpdateInningsModal.jsx"
import { compareNumStringValues } from "../../components/Common/Reusables/reusableMethods.js"
import WinnerModal from "./CommentaryModels/WinnerModal.jsx"
import UndoInnnigsModal from "./CommentaryModels/UndoInningsModal.jsx"
import CompleteCurrentMatchModal from "./CommentaryModels/CompleteMatchModal.jsx"
import ChangeBowlerModal from "./CommentaryModels/ChangeBowlerModal.jsx"
import UndoOverModal from "./CommentaryModels/UndoOverModal.jsx"
import OnPitchPlayerModal from "./CommentaryModels/OnPitchPlayerModal.jsx"
import { BATTING_STATUS, BOWLING_STATUS, COMMENTARY_UPDATE, ERROR, STRING_SEPERATOR, SUCCESS } from "../../components/Common/Const.js"
import { UndoErrorModal } from "./CommentaryModels/UndoErrorModal.jsx"
import { PenaltyModal } from "./CommentaryModels/PenaltyModal.jsx"
import RetiredHurtModal from "./CommentaryModels/RetiredHurtModal.jsx"
import SuperOverModal from "./CommentaryModels/SuperOverModal.jsx"
import { RetryModel } from "./CommentaryModels/RetryModel.jsx"
import axiosInstance from "../../Features/axios.js"
import CricketFieldModal from "./CommentaryModels/CricketFieldModal.jsx"
import { updateToastData } from "../../Features/toasterSlice.js"
import createSocket from "../../Features/socket.js"
import NewCommentaryScreen from "./NewCommentaryScreen.jsx"

const CommentaryNew = (props) => {
    const dispatch = useDispatch();
    const [propsData, setPropsData] = useState(undefined)
    const [commentaryDetails, setCommentaryDetails] = useState(undefined)
    const [matchTypeDetails, setMatchTypeDetails] = useState(undefined)
    const [isLastInnigs, setIsLastInnings] = useState(undefined)
    const [ballHistory, setBallHistory] = useState([])
    const [overHistory, setOverHistory] = useState([])
    const [wicketHistory, setWicketHistory] = useState([])
    const [partnershipHistory, setPartnershipHistory] = useState([])
    const [currentOver, setCurrentOver] = useState({})
    const [_currentOver, _setCurrentOver] = useState({})
    const [currentPartnership, setCurrentPartnership] = useState({})
    const [_currentPartnership, _setCurrentPartnership] = useState({})
    const [currentBall, setCurrentBall] = useState({})
    const [currentWicket, setCurrentWicket] = useState({})
    const [allInningaTeams, setAllIningsTeams] = useState([])
    const [teams, setTeams] = useState(undefined)
    const [_teams, _setTeams] = useState(undefined)
    const [players, setPlayers] = useState(undefined)
    const [_players, _setPlayers] = useState(undefined)
    const [onPitchPlayers, setOnPitchPlayers] = useState({})
    const [_onPitchPlayers, _setOnPitchPlayers] = useState({})
    const [changePlayerList, setChangePlayerList] = useState(undefined)
    const [extrasType, setExtrasType] = useState(undefined)
    const [playerToChange, setPlayerToChange] = useState(undefined)
    const [changeOverOnPopupClick, setChangeOverOnPopupClick] = useState(undefined)
    const [overPopUpForBowler, setOverPopUpForBowler] = useState(undefined)
    const [showChangeOverModal, setShowChangeOverModal] = useState(undefined)
    const [showWicketModal, setShowWicketModal] = useState(undefined)
    const [isBowlerrChange, setIsBowlerrChange] = useState(undefined)
    const [saveToDb, setSaveToDb] = useState(undefined)
    const [isOverChange, setIsOverChange] = useState(undefined)
    const [isPaneltyPopup, setIsPaneltyPopup] = useState(undefined)
    const [undoOverPopup, setUndoOverPopup] = useState(undefined)
    const [isWicketChange, setIsWicketChange] = useState(undefined)
    const [playerUpdateList, setPlayerUpdateList] = useState(undefined)
    const [inningsChangePopup, setShowInningsChangePopup] = useState(undefined)
    // const [inningsChangeClosed, setInningsChangeClosed] = useState(undefined)
    const [redirectOnScreenChange, setRedirectOnScreenChange] = useState(undefined)
    const [showUpdateInnings, setShowUpdateInnings] = useState(undefined)
    const [winnerAnnouncement, setWinnerAnnouncement] = useState(undefined)
    const [isUndoBall, setIsUndoBall] = useState(undefined)
    const [undoErrorModal, setUndoErrorModal] = useState(undefined)
    const [undoInningsPopup, setUndoInningsPopup] = useState(undefined)
    const [updateRunsFromWicket, setUpdateRunFromWicket] = useState(undefined)
    const [isSwapPlayer, setIsSwapPlayer] = useState(undefined)
    const [isChangeBowler, setIsChangeBowler] = useState({})
    const [completeMatchModal, setCompleteMatchModal] = useState(undefined)
    const [overBallByBallDisplay, setOverBallByBallDisplay] = useState([])
    const [selectMissingPlayer, setSelectMissingPlayer] = useState(undefined)
    const [showRretiredHurt, setShowRretiredHurt] = useState(false)
    const [target, setTarget] = useState(0)
    const [superOverModal, setSuperOverModal] = useState(0)
    const [checkIfUndoFromMaster, setCheckIfUndoFromMaster] = useState(false)
    const [superOverText, setSuperOverText] = useState(() => {
        return JSON.parse(localStorage.getItem("superOverText")) || false;
    });
    const [overTypeOptions, setOverTypeOptions] = useState([])
    const [selectedOverType, setSelectedOverType] = useState({})
    const [isDetaultOverType, setIsDefaultOverType] = useState(false)
    const [ballCountForStrike, setBallCountForStrike] = useState(1)
    const [retryModel, setRetryModel] = useState(undefined)
    const [isWonByInnings, setIsWonByInnings] = useState(undefined)
    const [isMatchCompleted, setIsMatchCompleted] = useState(undefined)
    const [showCricketFieldModal, setShowCricketFieldModal] = useState(undefined);
    const [cricketFieldData, setCricketFieldData] = useState(null);
    const [isWheelShow, setIsWheelShow] = useState(undefined);
    const [isRemainingBallsShow, setIsRemainingBallsShow] = useState(undefined);
    const [isWheelShowComplete, setIsWheelShowComplete] = useState(undefined);
    const [isUndoingLastOver, setIsUndoingLastOver] = useState(false);
    const [ballStatus, setBallStatus] = useState(null);
    const [isShotType, setIsShotType] = useState(undefined);
    const [lastUndoId, setLastUndoId] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isInningsUndoDone, setIsInningsUndoDone] = useState(null);
    const {
        commentaryDataToUpdate,
        isCommentaryDataUpdated,
        isUndoCompleted,
        isCommentaryBallLoading,
        superOverApiData, error
    } = useSelector(state => state.tabsData.commentary);
    let navigate = useNavigate();
    const socket = createSocket();

    // const throttledDispatchAdd = useMemo(
    //     () => _.throttle((data) => {
    //         dispatch(addCommentaryScreenData(data));
    //     }, 400, { leading: true, trailing: true }),
    //     [dispatch]
    // );
    // console.log({ "Current Over Ball count": currentOver.ballCount, "OverHistory": overHistory });

    // const handleCommentaryConsole = async (temp, main, objToSave, currentPartnership) => {
    //     const currentState = {
    //         over: main?.over,
    //         ballCount: main?.ballCount,
    //         teamScore: `${teams[BATTING_TEAM]?.teamScore || 0}/${teams[BATTING_TEAM]?.teamWicket || 0}`,
    //         commentaryBallByBall: objToSave?.commentaryBallByBall,
    //         commentaryPartnership: objToSave?.commentaryPartnership,
    //         commentaryPlayers: objToSave?.commentaryPlayers,
    //         currentPartnership: currentPartnership,
    //     }
    //     const temporaryState = {
    //         over: temp?.over,
    //         ballCount: temp?.ballCount,
    //         teamScore: typeof BATTING_TEAM !== 'undefined' && _teams?.[BATTING_TEAM]
    //             ? `${_teams[BATTING_TEAM]?.teamScore || 0}/${_teams[BATTING_TEAM]?.teamWicket || 0}`
    //             : '0/0',
    //     }
    //     const payload = {
    //         currentState: JSON.stringify(currentState),
    //         temporaryState: JSON.stringify(temporaryState),
    //         ballCount: main?.ballCount,
    //         over: main?.over,
    //         teamScore: `${teams[BATTING_TEAM]?.teamScore || 0}/${teams[BATTING_TEAM]?.teamWicket || 0}`,
    //         commentaryId: main?.commentaryId,
    //     }
    //     try {
    //         await axiosInstance.post(`/admin/score/commentaryConsoleFe`, payload);
    //     } catch (error) {
    //         console.error("Error updating commentary console:", error);
    //     }
    // };
    const syncOverCheck = isEmpty(_currentOver) ? currentOver : _currentOver;
    useEffect(() => {
        localStorage.setItem("superOverText", JSON.stringify(superOverText));
    }, [superOverText]);

    useEffect(() => {
        if(!inningsChangePopup && !redirectOnScreenChange){
            checkForOverSwitch(); // Trigger check whenever currentOver or ball count changes
        }
    }, [syncOverCheck.ballCount, isWheelShowComplete, isWheelShow, inningsChangePopup, redirectOnScreenChange]);

    const checkForOverSwitch = () => {
        const isBallCountExceeded = syncOverCheck.ballCount >= (matchTypeDetails?.ballsPerOver || 6);
        const shouldShowWheel = isWheelShowComplete || !isWheelShow;
        const isNotUndoing = !isUndoingLastOver;
        const isOverNotComplete = !syncOverCheck.isComplete;

        if (isNotUndoing && isBallCountExceeded && shouldShowWheel && isOverNotComplete) {
            setShowChangeOverModal(true);
        }
    };

    const checkInningsSwitch = (checkFor) => {
        const teamToCheck = _teams || teams
        const maxNoOfWicket = matchTypeDetails?.noOfPlayer - (matchTypeDetails?.isLastManStand ? 0 : 1);
        const isOverLimitReached = () => {
            return matchTypeDetails.isLimitedOvers &&
                (currentOver?.ballCount >= 5 && Math.ceil(+currentOver.over || 0) + 1) >= teamToCheck[BATTING_TEAM]?.teamMaxOver;
        };
        // const isWicketLimitReached = () => {
        //     return teamToCheck?.[BATTING_TEAM]?.teamWicket > maxNoOfWicket - 2;
        // };

        const isWicketLimitReached = () => {
            return teamToCheck?.[BATTING_TEAM]?.teamWicket >= maxNoOfWicket;
        };

        const isRunTargetAchieved = () => {
            return isLastInnigs && target !== 0 && teamToCheck?.[BATTING_TEAM]?.teamScore >= target;
        };

        let conditionsToCheck = [];
        switch (checkFor) {
            case 'ALL':
                conditionsToCheck = [isOverLimitReached(), isWicketLimitReached(), isRunTargetAchieved()]; break;
            case 'OVER':
                conditionsToCheck = [isOverLimitReached()]; break;
            case 'WICKET':
                conditionsToCheck = [isWicketLimitReached()]; break;
            case 'RUN':
                conditionsToCheck = [isRunTargetAchieved()]; break;
            default: break;
        }
        if (conditionsToCheck.some(condition => condition) && !isMatchCompleted) {
            const runDifference = (teams[BATTING_TEAM]?.teamScore || 0) + (teams[BATTING_TEAM]?.teamLeadRuns || 0) - (teams[BATTING_TEAM]?.teamTrialRuns || 0)
            if (teamToCheck?.[BOWLING_TEAM].isBattingComplete && isLastInnigs) {
                setCompleteMatchModal(true);
                setShowChangeOverModal(false);
            }
            else if (!teams[BOWLING_TEAM].isBattingComplete && isLastInnigs && runDifference < 0) {
                setIsWonByInnings(runDifference * -1);
                setCompleteMatchModal(true);
                setShowChangeOverModal(false);
            }
            else {
                setShowInningsChangePopup(true);
                setShowChangeOverModal(false);
            }
        }
    }
    const completeMatch = () => {
        const isMatchTie = teams?.[BATTING_TEAM]?.teamScore === target - 1;
        if (isMatchTie) { setSuperOverModal(true); setSuperOverText(true) }
        else checkWinner();
        setCompleteMatchModal(undefined);
        setChangePlayerList(undefined);
        setIsMatchCompleted(true)
    }
    const handleSuperOver = (superOverData) => {
        const currentPartnershipData = (isEmpty(_currentPartnership) ? currentPartnership : _currentPartnership);
        const partnershipDetails = {
            ...currentPartnershipData,
            "isActive": false,
        }
        const updatedPartnership = generatePartnership({ commentaryDetails, currentPartnership: partnershipDetails, teams, onPitchPlayers: (isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers) })
        const updatedOnPitchPlyer = { ...onPitchPlayers }
        const resetPlayers = Object.values(updatedOnPitchPlyer).map(player =>
            player ? { ...player, isPlay: null, onStrike: null } : null
        )?.filter(Boolean);
        let objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryPartnership": updatedPartnership,
            "commentaryPlayers": resetPlayers,
        }
        dispatch(addCommentaryScreenData(objToSave));
        const objToSend = {
            commentaryId: commentaryDetails.commentaryId,
            teamMaxOver: superOverData?.overs,
            battingTeamId: superOverData?.battingTeamId
        }
        dispatch(addSuperOverCall(objToSend));
        setSuperOverModal(false);
    }
    const checkWinner = () => {
        let WINNING_MESSAGE = ""
        let WINNING_RMK_MESSAGE = ""
        let WINNING_TEAM = ""
        let isBattingTeamWon = undefined
        if (isWonByInnings) {
            isBattingTeamWon = false
            WINNING_TEAM = BOWLING_TEAM
            WINNING_MESSAGE = `${teams?.[BOWLING_TEAM]?.shortName} won by innings and ${isWonByInnings} runs`
            WINNING_RMK_MESSAGE = `by innings and ${isWonByInnings} runs`
        } else if (superOverText) {
            isBattingTeamWon = teams?.[BATTING_TEAM]?.teamScore >= target
            WINNING_TEAM = isBattingTeamWon ? BATTING_TEAM : BOWLING_TEAM
            WINNING_MESSAGE = `${teams?.[WINNING_TEAM]?.shortName} won in super over`
            WINNING_RMK_MESSAGE = `in super over`
        } else {
            const isMatchTie = teams?.[BATTING_TEAM]?.teamScore === target - 1
            isBattingTeamWon = teams?.[BATTING_TEAM]?.teamScore >= target
            WINNING_TEAM = isBattingTeamWon ? BATTING_TEAM : BOWLING_TEAM
            WINNING_MESSAGE = isMatchTie ? `Match tied  between ${teams?.[BATTING_TEAM].teamName} and ${teams?.[BOWLING_TEAM].teamName}`
                : fetchWinnerMessage({ team: teams, matchTypeDetails, target, winningTeam: WINNING_TEAM, isBattingTeamWon })
            WINNING_RMK_MESSAGE = isMatchTie ? `Match tied`
                : fetchWinnerMessageRmk({ team: teams, matchTypeDetails, target, winningTeam: WINNING_TEAM, isBattingTeamWon })
        }
        const teamUpdates = [
            { ...teams?.[BATTING_TEAM], isBattingComplete: true, isWin: isBattingTeamWon },
            { ...teams?.[BOWLING_TEAM], isWin: !isBattingTeamWon }]
        const commentaryUpdates = {
            "commentaryStatus": 4,
            "winnerId": teams?.[WINNING_TEAM].teamId,
            "winnerName": teams?.[WINNING_TEAM].teamName,
            "displayStatus": "",
            "result": WINNING_MESSAGE,
            "winRmk": WINNING_RMK_MESSAGE,
        }
        let objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryDetails": {
                ...commentaryDetails,
                ...commentaryUpdates
            },
            "commentaryTeams": teamUpdates,
            "commentaryPlayers": Object.values(onPitchPlayers).filter(x => x),
        }
        //  console.log("objToSave", objToSave);
        dispatch(addCommentaryScreenData(objToSave))
        setIsWonByInnings(undefined)
        setShowInningsChangePopup(undefined)
        setCompleteMatchModal(undefined)
        setWinnerAnnouncement(WINNING_MESSAGE)
    }
    const retiringHurtPartnership = () => {
        const currentPartnershipData = (isEmpty(_currentPartnership) ? currentPartnership : _currentPartnership);
        const partnershipDetails = {
            ...currentPartnershipData,
            "isActive": false,
        }
        const updatedPartnership = generatePartnership({ commentaryDetails, currentPartnership: partnershipDetails, teams, onPitchPlayers: (isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers) })
        let objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryPartnership": updatedPartnership
        }
        // console.log("retiringHurtPartnership", retiringHurtPartnership)
        dispatch(addCommentaryScreenData(objToSave))
    }
    const onInningsChange = () => {
        let teamUpdates = undefined
        let commentaryUpdates = undefined
        let extraOverUpdate = null;
        const isWicketBall = currentBall?.ballIsWicket;
        const isLastBall = (currentOver?.ballCount) == matchTypeDetails?.ballsPerOver;
        const syncOnPitchPlayers = isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers;
        const currentBowler = syncOnPitchPlayers?.[CURRENT_BOWLER]
        const bowlerOver = currentBowler && Math.ceil(+currentBowler?.bowlerOver || 0);
        if (teams[BOWLING_TEAM].isBattingComplete && !isLastInnigs) {
            setShowUpdateInnings(true)
        }
        else {
            if(isWicketBall && isLastBall && currentBowler && bowlerOver) {
                const syncOver = isEmpty(_currentOver) ? currentOver : _currentOver;
                const syncTeams = isEmpty(_teams) ? teams : _teams;
                const updatedOver = {
                    ...syncOver,
                    "teamScore": `${syncTeams[BATTING_TEAM]?.teamScore || 0}/${syncTeams[BATTING_TEAM]?.teamWicket || 0}`,
                    "isMaiden": getBowlerOnlyRuns(syncOver) < 1,
                    "isComplete": true
                }
                // const updateBowler = {
                //     ...syncOnPitchPlayers[CURRENT_BOWLER],
                //     "isPlay": null,
                //     "bowlerOver": Math.ceil(+syncOnPitchPlayers[CURRENT_BOWLER].bowlerOver || 0),
                //     "bowlerMaidenOver": syncOver.totalRun < 1 ? 1 : 0
                // }
                extraOverUpdate = updatedOver;
            } 
            const runDifference = (teams[BATTING_TEAM]?.teamScore || 0) + (teams[BATTING_TEAM]?.teamLeadRuns || 0) - (teams[BATTING_TEAM]?.teamTrialRuns || 0)
            const trialRuns = Math.max(runDifference, 0)
            const leadRuns = Math.max(runDifference * -1, 0)
            teamUpdates = [
                { ...teams?.[BATTING_TEAM], isBattingComplete: true, teamStatus: 2 },
                { ...teams?.[BOWLING_TEAM], teamStatus: 1, teamTrialRuns: trialRuns, teamLeadRuns: leadRuns }]
            commentaryUpdates = {
                // "commentaryStatus": 2,
                "commentaryStatus": 5,
                "displayStatus": "Innings"
            }
            setRedirectOnScreenChange(true)
        }
        const currentPartnershipData = (isEmpty(_currentPartnership) ? currentPartnership : _currentPartnership);
        const partnershipDetails = {
            ...currentPartnershipData,
            "isActive": false,
        }
        const updatedPartnership = generatePartnership({ commentaryDetails, currentPartnership: partnershipDetails, teams, onPitchPlayers: (isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers) })
        let objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryDetails": {
                ...commentaryDetails,
                ...commentaryUpdates
            },
            "commentaryTeams": teamUpdates,
            "commentaryPartnership": updatedPartnership,
            "commentaryPlayers": setAllPlayerToNull(),
            "updateTeamStatus": extractRequiredFieldsForTeamStatus(teamUpdates),
            "isEndInnings": true,
            ...(extraOverUpdate && { commentaryOvers: extraOverUpdate })
        }
        if (!objToSave?.commentaryPartnership?.batter1Id && !objToSave?.commentaryPartnership?.batter2Id) {
            // handleCommentaryConsole(_currentOver, currentOver, objToSave, currentPartnership);
            dispatch(
                updateToastData({
                    title: 'Partnership issue',
                    data: 'batter1 or batter2 is null',
                    type: ERROR,
                })
            );
        }
        // console.log("Called from : 2")
        // console.log("onInningsChange", objToSave)
        dispatch(addCommentaryScreenData(objToSave))
        setShowInningsChangePopup(undefined)
    }
    // console.log("overHistory", overHistory)
    // console.log("ballHistory", ballHistory)
    // console.log("partnerShipHistory", partnershipHistory);
    const handleInningsUpdate = (battingTeamId) => {
        let updatedInningsTeam = [{ ...teams?.[BATTING_TEAM], isBattingComplete: true }]
        const runDifference = (teams[BATTING_TEAM]?.teamScore || 0) + (teams[BATTING_TEAM]?.teamLeadRuns || 0) - (teams[BATTING_TEAM]?.teamTrialRuns || 0)
        propsData.commentaryData?.commentaryTeams?.forEach(team => {
            if (team.currentInnings === (commentaryDetails.currentInnings + 1)) {
                let updatedTeam = team
                if (team.teamId === battingTeamId) {
                    updatedTeam["teamStatus"] = BATTING_STATUS
                    updatedTeam["teamBattingOrder"] = BATTING_STATUS + (+commentaryDetails.currentInnings * 2)
                    if (runDifference > 0) {
                        if (isEqual(+teams[BATTING_TEAM]?.teamId, +battingTeamId)) updatedTeam["teamLeadRuns"] = runDifference
                        else if (isEqual(+teams[BOWLING_TEAM]?.teamId, +battingTeamId)) updatedTeam["teamTrialRuns"] = runDifference
                    } else {
                        if (isEqual(+teams[BATTING_TEAM]?.teamId, +battingTeamId)) updatedTeam["teamTrialRuns"] = runDifference * -1
                        else if (isEqual(+teams[BOWLING_TEAM]?.teamId, +battingTeamId)) updatedTeam["teamLeadRuns"] = runDifference * -1
                    }
                } else {
                    updatedTeam["teamStatus"] = BOWLING_STATUS
                    updatedTeam["teamBattingOrder"] = BOWLING_STATUS + (+commentaryDetails.currentInnings * 2)
                }
                updatedInningsTeam.push(updatedTeam)
            }
        });
        let objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryDetails": {
                ...commentaryDetails,
                currentInnings: commentaryDetails.currentInnings + 1,
                commentaryStatus: 5,
                "displayStatus": "Innings"
            },
            "commentaryTeams": updatedInningsTeam,
            "commentaryPlayers": setAllPlayerToNull(),
            "updateTeamStatus": extractRequiredFieldsForTeamStatus(updatedInningsTeam),
            "isEndInnings": true
        }
        // console.log("Called from : 3")
        dispatch(addCommentaryScreenData(objToSave))
        setShowUpdateInnings(undefined)
        setRedirectOnScreenChange(true)
    }
    const setAllPlayerToNull = () => {
        const playersToChange = []
        players[BATTING_TEAM].map((player) => {
            if (player.commentaryPlayerId === onPitchPlayers[ON_STRIKE]?.commentaryPlayerId) {
                playersToChange.push({ ...onPitchPlayers[ON_STRIKE], "isPlay": null, "onStrike": null })
                return player
            }
            if (player.commentaryPlayerId === onPitchPlayers[NON_STRIKE]?.commentaryPlayerId) {
                playersToChange.push({ ...onPitchPlayers[NON_STRIKE], "isPlay": null, "onStrike": null })
                return player
            }
            else if (player.isPlay || player.onStrike) {
                playersToChange.push({ ...player, "isPlay": null, "onStrike": null })
                return player
            }
            return player
        })
        players[BOWLING_TEAM].map((player) => {
            if (player.commentaryPlayerId === onPitchPlayers[CURRENT_BOWLER]?.commentaryPlayerId) {
                playersToChange.push({ ...onPitchPlayers[CURRENT_BOWLER], "isPlay": null, "onStrike": null })
                return player
            }
            else if (player.isPlay || player.onStrike) {
                playersToChange.push({ ...player, "isPlay": null, "onStrike": null })
                return player
            }
            return player
        })
        return playersToChange
    }
    const callWicketToDB = (currentBallByBallID) => {
        const newCurrentBall = currentBall
        newCurrentBall["commentaryBallByBallId"] = currentBallByBallID
        const updatedPartnership = generatePartnership({ commentaryDetails, currentPartnership: isEmpty(_currentPartnership) ? currentPartnership : _currentPartnership, teams: _teams || teams, onPitchPlayers: (isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers) })
        const updatedBallByBall = generateBall({
            currentBall: newCurrentBall, commentaryDetails,
            currentOver: _currentOver || currentOver, onPitchPlayers: _onPitchPlayers || onPitchPlayers, teams: _teams || teams, currentPartnership
        })
        const updatedWicket = generateWicket({
            commentaryDetails, currentOver: _currentOver || currentOver,
            teams: _teams || teams, currentWicket, currentBall: newCurrentBall
        })
        const objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryDetails": {
                ...commentaryDetails,
                "displayStatus": generateDisplayStatus({ currentBall: updatedBallByBall, onStrikePlayer: onPitchPlayers[ON_STRIKE] }),
                "rmk": isRemainingBallsShow ? generateRemainingRuns(_teams ? _teams[BATTING_TEAM] : teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : ""
            },
            "commentaryOvers": {
                ..._currentOver,
                "teamScore": `${_teams[BATTING_TEAM]?.teamScore || 0}/${_teams[BATTING_TEAM]?.teamWicket || 0}`
            },
            "commentaryTeams": [_teams[BATTING_TEAM]],
            "commentaryPartnership": updatedPartnership,
            "commentaryBallByBall": updatedBallByBall,
            "commentaryWicket": updatedWicket,
            "commentaryPlayers": Object.values(_onPitchPlayers),
        }
        // console.log("Called from : 4")
        // console.log("callWicketToDB", objToSave)
        if (!objToSave?.commentaryPartnership?.batter1Id && !objToSave?.commentaryPartnership?.batter2Id) {
            // handleCommentaryConsole(_currentOver, currentOver, objToSave, currentPartnership);
            dispatch(
                updateToastData({
                    title: 'Partnership issue',
                    data: 'batter1 or batter2 is null',
                    type: ERROR,
                })
            );
        }
        setIsSaving(true);
        Promise.resolve(dispatch(addCommentaryScreenData(objToSave)))
            .finally(() => {
                setIsSaving(false);
            });
        _setOnPitchPlayers((prevValue) => {
            return {
                ...prevValue,
                [ON_STRIKE]: prevValue[ON_STRIKE].isPlay ? prevValue[ON_STRIKE] : null,
                [NON_STRIKE]: prevValue[NON_STRIKE].isPlay ? prevValue[NON_STRIKE] : null
            }
        })
        const updaterPartnershipHistory = partnershipHistory.slice(0, -1)
        setPartnershipHistory([].concat((updaterPartnershipHistory || []), [updatedPartnership]))
        setUpdateRunFromWicket(undefined)
        // checkForOverSwitch(onPitchPlayers[CURRENT_BOWLER]?.bowlerOver)
        checkInningsSwitch(ALL);
        setSaveToDb(false)
    }
    const updateRuns = ({ run, ball, batter, bowler, isBoundary, freezePlayers = false }) => {
        const syncOver = isEmpty(_currentOver) ? currentOver : _currentOver
        if (isCommentaryBallLoading || isSaving || syncOver?.isComplete) return;
        setIsSaving(true);
        setBallStatus(SCORING_STATUS);
        setIsUndoingLastOver(false);
        if (!freezePlayers) setCurrentBall({})
        const syncTeam = isEmpty(_teams) ? teams : _teams
        // const syncOver = isEmpty(_currentOver) ? currentOver : _currentOver
        const syncPartnership = isEmpty(_currentPartnership) ? currentPartnership : _currentPartnership
        const syncOnPitchPlayer = isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers
        const updateBattingTeam = {}
        let updateBatter = {}
        let updateBowler = {}
        const updateOver = {}
        const updatePartnership = {}
        const updateBall = {}
        let isChangeStrike = undefined
        // if (syncOver.ballCount < (+matchTypeDetails?.ballsPerOver || 6)) {
        const updatedBowlerOver = ball > 0 ? ((+bowler.bowlerOver || 0) + 0.1).toFixed(1) : bowler.bowlerOver
        updateBall["ballIsCount"] = ball > 0
        if (matchTypeDetails.isAutoChangeStriker && ball > 0) {
            updateBall["autoStrikeBallCount"] = ballCountForStrike
            setBallCountForStrike(ballCountForStrike + 1)
        }
        updateBall["ballType"] = BALL_TYPE_REGULAR
        updateBall["ballRun"] = run
        updateBall["batStrikeId"] = onPitchPlayers[ON_STRIKE].commentaryPlayerId
        updateBall["batNonStrikeId"] = onPitchPlayers[NON_STRIKE].commentaryPlayerId
        updateBatter["batRun"] = getNonNegativeValue((batter.batRun || 0) + run)
        updateBatter["batBall"] = getNonNegativeValue((batter.batBall || 0) + ball)
        updateBatter["batsmanStrikeRate"] = getStrikeRate(updateBatter.batRun, updateBatter.batBall)
        updateBowler["bowlerRun"] = getNonNegativeValue((+bowler.bowlerRun || 0) + run)
        updateBowler["bowlerTotalBall"] = getNonNegativeValue((+bowler.bowlerTotalBall || 0) + ball)
        updateBowler["bowlerOver"] = updatedBowlerOver
        updateBowler["bowlerEconomy"] = getEconomyRate(updateBowler.bowlerRun, updateBowler.bowlerTotalBall, matchTypeDetails.ballsPerOver)
        updatePartnership["totalRuns"] = getNonNegativeValue((syncPartnership.totalRuns || 0) + run)
        updatePartnership["totalBalls"] = getNonNegativeValue((syncPartnership.totalBalls || 0) + ball)
        // In updateRuns function where you update partnership data
        updatePartnership["batter1Runs"] = isEqual(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter1Id)
            ? (currentPartnership.batter1Runs || 0) + run
            : (currentPartnership.batter1Runs || 0);
        updatePartnership["batter2Runs"] = isEqual(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter2Id)
            ? (currentPartnership.batter2Runs || 0) + run
            : (currentPartnership.batter2Runs || 0);
        updatePartnership["batter1Balls"] = isEqual(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter1Id)
            ? (currentPartnership.batter1Balls || 0) + ball
            : (currentPartnership.batter1Balls || 0);
        updatePartnership["batter2Balls"] = isEqual(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter2Id)
            ? (currentPartnership.batter2Balls || 0) + ball
            : (currentPartnership.batter2Balls || 0);
        updateOver["ballCount"] = (syncOver.ballCount || 0) + ball
        updateOver["totalRun"] = (syncOver.totalRun || 0) + run
        updateBattingTeam["teamWicket"] = (+syncTeam[BATTING_TEAM].teamWicket || 0)
        updateBattingTeam["teamScore"] = (+syncTeam[BATTING_TEAM].teamScore || 0) + run
        updateBattingTeam["crr"] = getRunRate(updateBattingTeam.teamScore, { ...syncOver, ...updateOver }, matchTypeDetails.ballsPerOver)
        updateBattingTeam["teamOver"] = ball > 0 ?
            ((+syncTeam[BATTING_TEAM].teamOver || 0) + 0.1).toFixed(1) : syncTeam[BATTING_TEAM].teamOver
        if (matchTypeDetails.isLimitedOvers && (target > 0)) {
            updateBattingTeam["rrr"] = getRequiredRunRate(updateBattingTeam.teamScore,
                syncOver, matchTypeDetails.ballsPerOver, target, teams[BATTING_TEAM]?.teamMaxOver)
        }
        if (run === 0) {
            updateBall["ballIsDot"] = true
            updateBatter["batDotBall"] = (batter.batDotBall || 0) + ball
            updateOver["dotBall"] = (syncOver.dotBall || 0) + ball
            updateBowler["bowlerDotBall"] = (bowler.bowlerDotBall || 0) + ball
        } else if (isBoundary) {
            if (run === 4) {
                updateBall["ballIsBoundry"] = true
                updateBall["ballFour"] = 1
                updateBatter["batFour"] = (batter.batFour || 0) + 1
                updateOver["totalFour"] = (syncOver.totalFour || 0) + 1
                updatePartnership["totalFour"] = (currentPartnership.totalFour || 0) + 1
                updateBowler["bowlerFour"] = (bowler.bowlerFour || 0) + 1
            } else if (run === 6) {
                updateBall["ballIsBoundry"] = true
                updateBall["ballSix"] = 1
                updateBatter["batSix"] = (batter.batSix || 0) + 1
                updateOver["totalSix"] = (syncOver.totalSix || 0) + 1
                updatePartnership["totalSix"] = (currentPartnership.totalSix || 0) + 1
                updateBowler["bowlerSix"] = (bowler.bowlerSix || 0) + 1
            }
        } else if (run % 2 !== 0) isChangeStrike = freezePlayers ? false : true
        updateBatter = { ...syncOnPitchPlayer[ON_STRIKE], ...updateBatter, onStrike: isChangeStrike ? false : true }
        updateBowler = { ...syncOnPitchPlayer[CURRENT_BOWLER], ...updateBowler }
        const updateNonStriker = { ...syncOnPitchPlayer[NON_STRIKE], onStrike: isChangeStrike ? true : false }
        if (!freezePlayers) {
            updateNonStriker["onStrike"] = isChangeStrike ? true : false
            updateBatter["onStrike"] = isChangeStrike ? false : true
        }
        _setPlayers((prevValue) => {
            const actualPrevData = isEmpty(prevValue) ? players : prevValue
            return {
                [BOWLING_TEAM]: actualPrevData?.[BOWLING_TEAM]?.map(player => compareNumStringValues(player.commentaryPlayerId, updateBowler.commentaryPlayerId) ? updateBowler : player),
                [BATTING_TEAM]: actualPrevData?.[BATTING_TEAM]?.map(player => {
                    if (compareNumStringValues(player.commentaryPlayerId, updateBatter.commentaryPlayerId))
                        return updateBatter
                    else if (compareNumStringValues(player.commentaryPlayerId, updateNonStriker.commentaryPlayerId))
                        return updateNonStriker
                    else return player
                })
            }
        })
        _setOnPitchPlayers({ [ON_STRIKE]: isChangeStrike ? updateNonStriker : updateBatter, [NON_STRIKE]: isChangeStrike ? updateBatter : updateNonStriker, [CURRENT_BOWLER]: updateBowler })
        _setTeams((prevValue) => {
            const actualPrevData = isEmpty(prevValue) ? teams : prevValue
            return { ...actualPrevData, [BATTING_TEAM]: { ...actualPrevData[BATTING_TEAM], ...updateBattingTeam } }
        })
        setCurrentBall((prevValue) => { return { ...prevValue, ...updateBall } })
        _setCurrentOver((prevValue) => {
            const actualPrevData = isEmpty(prevValue) ? currentOver : prevValue
            return { ...actualPrevData, ...updateOver, }
        })
        _setCurrentPartnership((prevValue) => {
            const actualPrevData = isEmpty(prevValue) ? currentPartnership : prevValue
            return { ...actualPrevData, ...updatePartnership, isActive: freezePlayers ? false : true }
        })
        setSaveToDb(true)
        // console.log("updatesRuns", currentPartnership)
    }

    const onBowlingTypeChange = async (selected) => {
        if (!selected) return;

        const updatedBowler = {
            ...onPitchPlayers[CURRENT_BOWLER],
            bowlingType: selected.value,
        };

        const payload = {
            commentaryId: commentaryDetails.commentaryId,
            commentaryPlayerId: updatedBowler?.commentaryPlayerId,
            bowlingType: updatedBowler?.bowlingType,
        };

        await axiosInstance
            .post(`/admin/commentary/bowlingTypeChange`, payload)
            .then((response) => {
                const updatedPlayers = {
                    ...onPitchPlayers,
                    [CURRENT_BOWLER]: updatedBowler,
                };
                setOnPitchPlayers(updatedPlayers);
                // _setOnPitchPlayers(updatedPlayers);
                dispatch(
                    updateToastData({
                        data: response?.message,
                        title: response?.title,
                        type: SUCCESS,
                    })
                );
            })
            .catch((error) => {
                dispatch(
                    updateToastData({
                        data: error?.message,
                        title: error?.title,
                        type: ERROR,
                    })
                );
            });
    };

    const updateExtras = (type, runs, isBoundary = false) => {
        setIsUndoingLastOver(false)
        setCurrentBall({})
        const bowler = onPitchPlayers[CURRENT_BOWLER]
        const batter = onPitchPlayers[ON_STRIKE]
        const updateBattingTeam = {}
        const updateOver = {}
        const updateBall = {}
        const updatePartnership = {}
        const updateBowler = {}
        const updatedBowlerOver = ((+bowler.bowlerOver || 0) + 0.1).toFixed(1)
        updateBattingTeam["teamWicket"] = (+teams[BATTING_TEAM].teamWicket || 0)
        if (isBoundary) {
            if (+runs === 4) {
                updateBall["ballIsBoundry"] = true
                updateBall["ballFour"] = 1
                batter["batFour"] = type === NO_BALL ? (batter.batFour || 0) + 1 : (batter.batFour || 0)
                updateOver["totalFour"] = (currentOver.totalFour || 0) + 1
                updatePartnership["totalFour"] = type === NO_BALL ? (currentPartnership.totalFour || 0) + 1 : (currentPartnership.totalFour || 0)
                updateBowler["bowlerFour"] = (bowler.bowlerFour || 0) + 1
            } else if (+runs === 6) {
                updateBall["ballIsBoundry"] = true
                updateBall["ballSix"] = 1
                batter["batSix"] = type === NO_BALL ? (batter.batSix || 0) + 1 : (batter.batSix || 0)
                updateOver["totalSix"] = (currentOver.totalSix || 0) + 1
                updatePartnership["totalSix"] = type === NO_BALL ? (currentPartnership.totalSix || 0) + 1 : (currentPartnership.totalSix || 0)
                updateBowler["bowlerSix"] = (bowler.bowlerSix || 0) + 1
            }
        }
        if (type === BALL_WIDE) {
            const valueOfWideBall = (+matchTypeDetails["valueOfWideBall"] || 0);
            const runToUpdate = valueOfWideBall + runs
            updateBowler["bowlerWideBall"] = (bowler.bowlerWideBall || 0) + 1
            updateBowler["bowlerWideBallRun"] = (bowler.bowlerWideBallRun || 0) + runToUpdate
            updateBowler["bowlerRun"] = (bowler.bowlerRun || 0) + runToUpdate
            updateBowler["bowlerEconomy"] = getEconomyRate(updateBowler.bowlerRun, bowler.bowlerTotalBall, matchTypeDetails.ballsPerOver)
            updateBattingTeam["teamWideRuns"] = (teams[BATTING_TEAM].teamWideRuns || 0) + runToUpdate
            updateBattingTeam["teamScore"] = (teams[BATTING_TEAM].teamScore || 0) + runToUpdate
            updateOver["totalWideBall"] = (currentOver.totalWideBall || 0) + 1
            updateOver["totalWideRun"] = (currentOver.totalWideRun || 0) + runToUpdate
            updateOver["totalRun"] = (currentOver.totalRun || 0) + runToUpdate
            updateBall["ballIsCount"] = false
            updateBall["ballRun"] = runs
            updateBall["ballExtraRun"] = runToUpdate
            updateBall["ballType"] = BALL_TYPE_WIDE
            updatePartnership["totalRuns"] = currentPartnership.totalRuns + runToUpdate
            updatePartnership["extras"] = currentPartnership.extras + runToUpdate
        } else if (type === NO_BALL || type === NO_BALL_BYE || type === NO_BALL_LEG_BYE) {
            const valueOfNoBall = (+matchTypeDetails["valueOfNoBall"] || 0)
            const runToUpdate = valueOfNoBall + runs
            updateBowler["bowlerNoBall"] = (bowler.bowlerNoBall || 0) + 1
            updateBowler["bowlerNoBallRun"] = (bowler.bowlerNoBallRun || 0) + valueOfNoBall
            updateBattingTeam["teamScore"] = (teams[BATTING_TEAM].teamScore || 0) + runToUpdate
            updateBattingTeam["teamNoBallRuns"] = (teams[BATTING_TEAM].teamNoBallRuns || 0) + valueOfNoBall
            updateOver["totalRun"] = (currentOver.totalRun || 0) + runToUpdate
            updateOver["totalNoball"] = (currentOver.totalNoball || 0) + 1
            updateOver["totalNoBallRun"] = (currentOver.totalNoBallRun || 0) + valueOfNoBall
            updateBall["ballIsCount"] = false
            updateBall["ballRun"] = runs
            updatePartnership["totalBalls"] = currentPartnership.totalBalls + 1
            updateBall["ballExtraRun"] = valueOfNoBall
            updatePartnership["batter1Balls"] = currentPartnership.batter1Balls +
                (compareNumStringValues(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter1Id) ? 1 : 0);
            updatePartnership["batter2Balls"] = currentPartnership.batter2Balls +
                (compareNumStringValues(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter2Id) ? 1 : 0);
            if (type === NO_BALL) {
                updateBowler["bowlerRun"] = (bowler.bowlerRun || 0) + runToUpdate
                updateBall["ballType"] = BALL_TYPE_NO_BALL
                batter["batRun"] = (batter.batRun || 0) + runs
                updatePartnership["extras"] = currentPartnership.extras + valueOfNoBall
                updatePartnership["batter1Runs"] = currentPartnership.batter1Runs +
                    (compareNumStringValues(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter1Id) ? runs : 0);
                updatePartnership["batter2Runs"] = currentPartnership.batter2Runs +
                    (compareNumStringValues(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter2Id) ? runs : 0);
            } else if (type === NO_BALL_BYE) {
                updateBowler["bowlerRun"] = (bowler.bowlerRun || 0) + valueOfNoBall
                updateBall["ballType"] = BALL_TYPE_NO_BALL_BYE
                updateBowler["bowlerByeBallRun"] = (bowler.bowlerByeBallRun || 0) + runs
                updateOver["totalByesRun"] = (currentOver.totalByesRun || 0) + runs
                updatePartnership["extras"] = currentPartnership.extras + runToUpdate
                updateBattingTeam["teamByRuns"] = (teams[BATTING_TEAM].teamByRuns || 0) + runs
            }
            else if (type === NO_BALL_LEG_BYE) {
                updateBall["ballType"] = BALL_TYPE_NO_BALL_LEG_BYE
                updateBowler["bowlerRun"] = (bowler.bowlerRun || 0) + valueOfNoBall
                updateBowler["bowlerNoBallRun"] = (bowler.bowlerNoBallRun || 0) + runs
                updateOver["totalLegByesRun"] = (currentOver.totalLegByesRun || 0) + runs
                updatePartnership["extras"] = currentPartnership.extras + runToUpdate
                updateBattingTeam["teamLegByRuns"] = (teams[BATTING_TEAM].teamLegByRuns || 0) + runs
            }
            batter["batBall"] = (batter.batBall || 0) + 1
            batter["batsmanStrikeRate"] = getStrikeRate(batter.batRun, batter.batBall)
            updatePartnership["totalRuns"] = currentPartnership.totalRuns + runToUpdate
            updateBowler["bowlerEconomy"] = getEconomyRate(updateBowler.bowlerRun, bowler.bowlerTotalBall, matchTypeDetails.ballsPerOver)
        }
        else {
            updateBowler["bowlerOver"] = updatedBowlerOver
            updateBowler["bowlerTotalBall"] = (bowler.bowlerTotalBall || 0) + 1
            updateBowler["bowlerRun"] = (bowler.bowlerRun || 0)
            updateBowler["bowlerEconomy"] = getEconomyRate(updateBowler.bowlerRun, updateBowler.bowlerTotalBall, matchTypeDetails.ballsPerOver)
            updateOver["ballCount"] = (currentOver.ballCount || 0) + 1
            batter["batBall"] = (batter.batBall || 0) + 1
            updateOver["totalRun"] = (currentOver.totalRun || 0) + runs
            updateBattingTeam["teamScore"] = (teams[BATTING_TEAM].teamScore || 0) + runs
            updatePartnership["totalRuns"] = currentPartnership.totalRuns + runs
            updatePartnership["extras"] = currentPartnership.extras + runs
            updatePartnership["totalBalls"] = currentPartnership.totalBalls + 1
            updateBall["ballIsCount"] = true
            updateBall["autoStrikeBallCount"] = ballCountForStrike
            updateBall["ballRun"] = runs
            updateBall["ballExtraRun"] = runs
            updateBattingTeam["teamOver"] =
                ((+teams[BATTING_TEAM].teamOver || 0) + 0.1).toFixed(1)
            batter["batsmanStrikeRate"] = getStrikeRate(batter.batRun, batter.batBall)
            updatePartnership["batter1Balls"] = currentPartnership.batter1Balls +
                (compareNumStringValues(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter1Id) ? 1 : 0);
            updatePartnership["batter2Balls"] = currentPartnership.batter2Balls +
                (compareNumStringValues(onPitchPlayers[ON_STRIKE].commentaryPlayerId, currentPartnership.batter2Id) ? 1 : 0);
            if (type === BALL_BYE) {
                updateBowler["bowlerByeBall"] = (bowler.bowlerByeBall || 0) + 1
                updateBowler["bowlerByeBallRun"] = (bowler.bowlerByeBallRun || 0) + runs
                updateOver["totalByesBall"] = (currentOver.totalByesBall || 0) + 1
                updateOver["totalByesRun"] = (currentOver.totalByesRun || 0) + runs
                updateBall["ballType"] = BALL_TYPE_BYE
                updateBattingTeam["teamByRuns"] = (teams[BATTING_TEAM].teamByRuns || 0) + runs
            }
            else if (type === BALL_LEG_BYE) {
                updateBowler["bowlerLegByeBall"] = (bowler.bowlerLegByeBall || 0) + 1
                updateBowler["bowlerLegByeBallRun"] = (bowler.bowlerLegByeBallRun || 0) + runs
                updateOver["totalLegByesBall"] = (currentOver.totalLegByesBall || 0) + 1
                updateOver["totalLegByesRun"] = (currentOver.totalLegByesRun || 0) + runs
                updateBall["ballType"] = BALL_TYPE_LEG_BYE
                updateBattingTeam["teamLegByRuns"] = (teams[BATTING_TEAM].teamLegByRuns || 0) + runs
            }
            setBallCountForStrike(ballCountForStrike + 1)
        }
        if (matchTypeDetails.isLimitedOvers && (target > 0)) {
            updateBattingTeam["rrr"] = getRequiredRunRate(updateBattingTeam.teamScore,
                currentOver, matchTypeDetails.ballsPerOver, target, teams[BATTING_TEAM]?.teamMaxOver)
        }
        const isStrikeChange = runs % 2 !== 0
        updateBattingTeam["crr"] = getRunRate(updateBattingTeam.teamScore, { ...currentOver, ...updateOver }, matchTypeDetails.ballsPerOver)
        updateBall["batStrikeId"] = onPitchPlayers[ON_STRIKE].commentaryPlayerId
        updateBall["batNonStrikeId"] = onPitchPlayers[NON_STRIKE].commentaryPlayerId
        const updatedOnStrike = { ...onPitchPlayers[ON_STRIKE], ...batter }
        const updateBatter = isStrikeChange ? onPitchPlayers[NON_STRIKE] : updatedOnStrike
        const updateNonStriker = !isStrikeChange ? onPitchPlayers[NON_STRIKE] : updatedOnStrike
        updateBatter["onStrike"] = true
        updateNonStriker["onStrike"] = false
        _setOnPitchPlayers({ [ON_STRIKE]: updateBatter, [NON_STRIKE]: updateNonStriker, [CURRENT_BOWLER]: { ...onPitchPlayers[CURRENT_BOWLER], ...updateBowler } })
        _setPlayers({
            [BOWLING_TEAM]: players?.[BOWLING_TEAM].map(player => compareNumStringValues(player.commentaryPlayerId, updateBowler.commentaryPlayerId) ? updateBowler : player),
            [BATTING_TEAM]: players?.[BATTING_TEAM].map(player => {
                if (compareNumStringValues(player.commentaryPlayerId, updateBatter.commentaryPlayerId))
                    return updateBatter
                else if (compareNumStringValues(player.commentaryPlayerId, updateNonStriker.commentaryPlayerId))
                    return updateNonStriker
                else return player
            })
        })
        _setTeams({ ...teams, [BATTING_TEAM]: { ...teams[BATTING_TEAM], ...updateBattingTeam } })
        _setCurrentOver({ ...currentOver, ...updateOver })
        _setCurrentPartnership({ ...currentPartnership, ...updatePartnership })
        setCurrentBall((prevValue) => { return { ...prevValue, ...updateBall } })
        setSaveToDb(true)
    }
    const updatePanelty = (runs) => {
        const updateBall = {}
        const updateBattingTeam = teams[BATTING_TEAM]
        updateBattingTeam["teamScore"] = (+teams[BATTING_TEAM].teamScore || 0) + runs
        updateBattingTeam["teamPenaltyRuns"] = (+teams[BATTING_TEAM].teamPenaltyRuns || 0) + runs
        updateBattingTeam["crr"] = getRunRate(updateBattingTeam.teamScore, { ...currentOver }, matchTypeDetails.ballsPerOver)
        if (matchTypeDetails.isLimitedOvers && (target > 0)) {
            updateBattingTeam["rrr"] = getRequiredRunRate(updateBattingTeam.teamScore,
                currentOver, matchTypeDetails.ballsPerOver, target, teams[BATTING_TEAM]?.teamMaxOver)
        }
        updateBall["commentaryBallByBallId"] = "0"
        updateBall["ballIsCount"] = false
        updateBall["ballRun"] = runs
        updateBall["ballExtraRun"] = runs
        updateBall["ballType"] = BALL_TYPE_PANELTY_RUN
        setCurrentBall(updateBall)
        setTeams({ ...teams, [BATTING_TEAM]: updateBattingTeam })
        const generatedBallByBall = generateBall({ currentBall: updateBall, commentaryDetails, currentOver, onPitchPlayers, teams, currentPartnership })
        const objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryBallByBall": generatedBallByBall,
            "commentaryDetails": { ...commentaryDetails, "displayStatus": `Penalty ${runs} runs`, "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : "" },
            "commentaryTeams": [updateBattingTeam],
        }
        // console.log("Called from : 5")
        dispatch(addCommentaryScreenData(objToSave))
        checkInningsSwitch(RUN)
    }
    const changeOver = () => {
        const syncOver = isEmpty(_currentOver) ? currentOver : _currentOver;
        const syncTeams = isEmpty(_teams) ? teams : _teams;
        const syncOnPitchPlayers = isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers;
        // console.log("Starting changeOver - Initial states:", { currentTeamOver: teams[BATTING_TEAM].teamOver });
        let updateBattingTeam = {
            ...syncTeams[BATTING_TEAM],
            "teamOver": Math.ceil(+syncTeams[BATTING_TEAM].teamOver || 0)
        }
        // console.log("Updated batting team:", updateBattingTeam);

        const updateBowler = {
            ...syncOnPitchPlayers[CURRENT_BOWLER],
            "isPlay": null,
            "bowlerOver": Math.ceil(+syncOnPitchPlayers[CURRENT_BOWLER].bowlerOver || 0),
            "bowlerMaidenOver": syncOver.totalRun < 1 ? 1 : 0
        }
        // console.log("Updated bowler details:", updateBowler);

        const updatedOver = {
            ...syncOver,
            "teamScore": `${syncTeams[BATTING_TEAM]?.teamScore || 0}/${syncTeams[BATTING_TEAM]?.teamWicket || 0}`,
            "isMaiden": getBowlerOnlyRuns(syncOver) < 1,
            "isComplete": true
        }
        // console.log("Updated over details:", updatedOver);

        setPlayerUpdateList([].concat([updateBowler], playerUpdateList || []))
        setTeams({ ...syncTeams, [BATTING_TEAM]: updateBattingTeam })
        setPlayers((prevValue) => { return { ...prevValue, [BOWLING_TEAM]: prevValue?.[BOWLING_TEAM].map(player => compareNumStringValues(player.commentaryPlayerId, updateBowler.commentaryPlayerId) ? updateBowler : player), } })
        // console.log("players in change over", players)
        setCurrentOver(updatedOver)
        setIsSaving(true);
        const objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryDetails": {
                ...commentaryDetails,
                "displayStatus": "Over",
                "rmk": isRemainingBallsShow ? generateRemainingRuns(syncTeams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : ""
            },
            "commentaryOvers": updatedOver,
            "commentaryPlayers": [updateBowler],
            "commentaryTeams": [updateBattingTeam],
        }
        // console.log("Final dispatch object:", objToSave);
        dispatch(addCommentaryScreenData(objToSave));
        _setTeams({});
        _setCurrentOver({});
        _setOnPitchPlayers({});
        _setPlayers({});
    }
    const changeStrike = () => {
        _setOnPitchPlayers((prevValue) => {
            const syncOnPitchPlayer = isEmpty(prevValue) ? onPitchPlayers : prevValue
            return {
                ...syncOnPitchPlayer,
                [ON_STRIKE]: { ...syncOnPitchPlayer[NON_STRIKE], onStrike: true },
                [NON_STRIKE]: { ...syncOnPitchPlayer[ON_STRIKE], onStrike: false }
            }
        })
        _setOnPitchPlayers((prevValue) => {
            const syncOnPitchPlayer = isEmpty(prevValue) ? onPitchPlayers : prevValue
            const objToSave = {
                "commentaryId": commentaryDetails.commentaryId,
                "isCallPredict": props?.isPredictToggle,
                "commentaryDetails": {
                    ...commentaryDetails,
                    "displayStatus": "",
                    "rmk": isRemainingBallsShow ? generateRemainingRuns(_teams ? _teams[BATTING_TEAM] : teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : ""
                },
                "commentaryPlayers": Object.values(syncOnPitchPlayer),
            }
            // console.log("Called from : 7");
            dispatch(addCommentaryScreenData(objToSave))
            _setPlayers((prevValue) => {
                const syncPlayers = isEmpty(prevValue) ? players : prevValue
                const updatedList = {
                    ...syncPlayers,
                    [BATTING_TEAM]: syncPlayers?.[BATTING_TEAM].map(player => {
                        if (compareNumStringValues(player.commentaryPlayerId, syncOnPitchPlayer[ON_STRIKE].commentaryPlayerId))
                            return syncOnPitchPlayer[ON_STRIKE]
                        else if (compareNumStringValues(player.commentaryPlayerId, syncOnPitchPlayer[NON_STRIKE].commentaryPlayerId))
                            return syncOnPitchPlayer[NON_STRIKE]
                        else return player
                    })
                }
                return updatedList

            })
            return prevValue
        })
    }
    // const playerCheck = onPitchPlayers
    const handleMissingPlayerChange = (playerType, player) => {
        // const order = props.data.commentaryData.commentaryPartnership[0].order
        const order = props.data.commentaryData.commentaryTeams.filter((t) => t.teamBattingOrder === 1)
        const commentaryDetailsobj = props.data.commentaryData.commentaryDetails
        const onPitchPlayersobj = { ...onPitchPlayers, [playerType]: player }
        const updatedOnPitchPlyer = { ...onPitchPlayers, [playerType]: { ...player, "isPlay": true, "isPlayInEvent" : true } }
        const partnershipDetails = {
            "batter1Id": onPitchPlayersobj[ON_STRIKE]?.commentaryPlayerId,
            "batter1Name": onPitchPlayersobj[ON_STRIKE]?.playerName,
            "batter2Id": onPitchPlayersobj[NON_STRIKE]?.commentaryPlayerId,
            "batter2Name": onPitchPlayersobj[NON_STRIKE]?.playerName,
            "order": order[0].teamWicket,
            // "order": order + 1,
            "isActive": true,
            "commentaryBallByBallId": (currentBall.commentaryBallByBallId || "0"),
        }
        const updatedPartnership = generatePartnership({ commentaryDetails: commentaryDetailsobj, currentPartnership: partnershipDetails, teams, onPitchPlayers: (isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers) })
        let objToSave = {}
        if (isEmpty(currentPartnership)) {
            objToSave = {
                "commentaryId": commentaryDetails.commentaryId,
                "isCallPredict": props?.isPredictToggle,
                "commentaryDetails": {
                    ...commentaryDetails,
                    "displayStatus": "Player Changed",
                    "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : ""
                },
                "commentaryPartnership": updatedPartnership,
                "commentaryPlayers": Object.values(updatedOnPitchPlyer),
            }
        } else {
            objToSave = {
                "commentaryId": commentaryDetails.commentaryId,
                "isCallPredict": props?.isPredictToggle,
                "commentaryDetails": {
                    ...commentaryDetails,
                    "displayStatus": "Player Changed",
                    "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : ""
                },
                "commentaryPlayers": Object.values(updatedOnPitchPlyer),
            }
        }
        if (playerType === CURRENT_BOWLER) {
            if (!currentOver || currentOver.isComplete) {
                setCurrentOver(overHistory[overHistory.length - 1])
                objToSave["commentaryOvers"] = generateOver({ commentaryDetails, onPitchPlayers: updatedOnPitchPlyer, teams, selectedOverType })
            }
        }
        setOnPitchPlayers(updatedOnPitchPlyer)
        // console.log("Called from : 8")
        // console.log("handleMissingPlayerChange", objToSave)
        dispatch(addCommentaryScreenData(objToSave))
        setSelectMissingPlayer(false)
        setIsBowlerrChange(false)
    }
    const handleWicket = (wicketData) => {
        // if (!wicketData.isExtraWicket)
        if (isWheelShow) {
            setShowCricketFieldModal(true);
            setCricketFieldData({ commentaryId: commentaryDetails.commentaryId, commentaryBallByBallId: currentBall?.commentaryBallByBallId, run: currentBall?.ballRun, isBoundary: currentBall?.ballIsBoundry, batter: onPitchPlayers[ON_STRIKE]?.playerName, bowler: onPitchPlayers[CURRENT_BOWLER]?.playerName, overCount: currentBall?.overCount });
        }
        setCurrentBall({})
        const ballToUpdateOnWicket = (wicketData.isExtraWicket || (wicketData.wicketType === RETIRED_OUT) || (wicketData.wicketType === TIMED_OUT)) ? 0 : 1
        setIsWicketChange(true)
        const updateBattingTeam = {}
        const updateBall = {}
        const updateWicket = {}
        let updateBowler = {}
        let updateOver = {}
        let updatedBatter = {}
        updateBall["ballIsWicket"] = true
        updateBall["ballWicketType"] = wicketData.wicketType
        updateBall["ballFielderId1"] = wicketData.fielder1
        updateBall["ballFielderId2"] = wicketData.fielder2
        updateBall["batStrikeId"] = onPitchPlayers[ON_STRIKE].commentaryPlayerId
        updateBall["batNonStrikeId"] = onPitchPlayers[NON_STRIKE].commentaryPlayerId
        updateWicket["bowlerId"] = onPitchPlayers[CURRENT_BOWLER].commentaryPlayerId
        updateWicket["bowlerName"] = onPitchPlayers[CURRENT_BOWLER].playerName
        updateWicket["wicketType"] = wicketData.wicketType
        updateWicket["fieldPlayerId"] = wicketData.fielder1
        updateWicket["fieldPlayerName"] = wicketData.fielder1Name
        updateWicket["fieldPlayer2Id"] = wicketData.fielder2
        updateWicket["fieldPlayer2Name"] = wicketData.fielder2Name
        const isOnStrikeWicket = isEqual(wicketData.batterId, onPitchPlayers[ON_STRIKE].commentaryPlayerId)
        const wicketPlayerDetails = onPitchPlayers[isOnStrikeWicket ? ON_STRIKE : NON_STRIKE]
        updateOver["totalWicket"] = (currentOver.totalWicket || 0) + 1
        updateBattingTeam["teamWicket"] = (teams[BATTING_TEAM].teamWicket || 0) + 1
        if (!LIST_TO_EXCLUDE_WICKET_FOR_BOWLER.includes(wicketData.wicketType))
            updateBowler["bowlerTotalWicket"] = (onPitchPlayers[CURRENT_BOWLER].bowlerTotalWicket || 0) + 1
        updateBall["ballPlayerId"] = wicketPlayerDetails.commentaryPlayerId
        updateWicket["batterId"] = wicketPlayerDetails.commentaryPlayerId
        updateWicket["batterName"] = wicketPlayerDetails.playerName
        updateWicket["wicketCount"] = updateBattingTeam.teamWicket
        updateWicket["batterRuns"] = wicketPlayerDetails.batRun + (isOnStrikeWicket ? +wicketData.runs : 0)
        // updateWicket["batterBalls"] = wicketPlayerDetails.batBall + isOnStrikeWicket ? ballToUpdateOnWicket : 0
        updateWicket["batterBalls"] = wicketData.balls
        const updatedBattingPlayers = players[BATTING_TEAM]?.map((player) => {
            if (isEqual(player.commentaryPlayerId, wicketData.batterId)) {
                const playerDataToList = {
                    ...player,
                    "isBatterOut": true,
                    // "isBatterRetir": wicketData.wicketType === RETIRED_OUT,
                    "isBatterRetir": (
                        wicketData.wicketType === RETIRED_OUT ||
                        wicketData.wicketType === RETIRED_HURT
                    ),
                    "wicketType": wicketData.wicketType,
                    "bowlerId": onPitchPlayers[CURRENT_BOWLER].commentaryPlayerId,
                    "fielderId1": wicketData.fielder1,
                    "fielderId2": wicketData.fielder2,
                    "isPlay": null,
                    "onStrike": null,
                }
                updatedBatter = playerDataToList
                return playerDataToList
            }
            return player
        })
        _setPlayers({ ...players, [BATTING_TEAM]: updatedBattingPlayers })
        _setOnPitchPlayers({
            [ON_STRIKE]: isOnStrikeWicket ? updatedBatter : onPitchPlayers[ON_STRIKE],
            [NON_STRIKE]: !isOnStrikeWicket ? updatedBatter : onPitchPlayers[NON_STRIKE],
            [CURRENT_BOWLER]: { ...onPitchPlayers[CURRENT_BOWLER], ...updateBowler }
        })
        _setTeams({ ...teams, [BATTING_TEAM]: { ...teams[BATTING_TEAM], ...updateBattingTeam } })
        _setCurrentOver({ ...currentOver, ...updateOver })
        setCurrentBall((prevValue) => { return { ...prevValue, ...updateBall } })
        changePlayer(isOnStrikeWicket ? ON_STRIKE : NON_STRIKE)
        setCurrentWicket(updateWicket)
        setShowWicketModal(undefined)
        checkInningsSwitch(WICKET)
        setExtrasType(undefined)
        setUpdateRunFromWicket({ run: +wicketData.runs, ball: ballToUpdateOnWicket, batter: onPitchPlayers[ON_STRIKE], bowler: onPitchPlayers[CURRENT_BOWLER], type: "", freezePlayers: true })
    }
    const onExtrasChange = (dataFromModal) => {
        updateExtras(extrasType, +dataFromModal.run, dataFromModal.isBoundary)
        if (dataFromModal.type === WICKET) setShowWicketModal(true)
        else setExtrasType(undefined)
    }
    const onPlayerChange = (newPlayerId, overTypeToChange) => {
        const teamType = playerToChange === CURRENT_BOWLER ? BOWLING_TEAM : BATTING_TEAM
        const updateOrderKey = playerToChange === CURRENT_BOWLER ? "bowlerOrder" : "batterOrder"
        // console.log("onPlayerChange onPitchPlayers", onPitchPlayers)
        let updatedOnPitchPlayer = { ...onPitchPlayers }
        // console.log("updatedOnPitchPlayer", updatedOnPitchPlayer)
        let secondPitchPlayerId
        if (onPitchPlayers[ON_STRIKE]?.commentaryPlayerId) {
            if (isEqual(onPitchPlayers[ON_STRIKE]?.commentaryPlayerId, currentWicket?.batterId)) {
                secondPitchPlayerId = onPitchPlayers[NON_STRIKE]?.commentaryPlayerId
            } else secondPitchPlayerId = onPitchPlayers[ON_STRIKE]?.commentaryPlayerId
        } else secondPitchPlayerId = onPitchPlayers[NON_STRIKE]?.commentaryPlayerId
        // const playerToChangeId = onPitchPlayers[playerToChange]?.commentaryPlayerId
        const allPlayersToUpdate = []

        setPlayers((prevValue) => {
            return {
                ...prevValue,
                [teamType]: prevValue[teamType]?.map((player) => {
                    // condition to set for new selected player for both batter and bowler
                    if (isEqual(player.commentaryPlayerId, newPlayerId)) {
                        const updatedPlayer = {
                            ...player, "isPlay": true, "onStrike": playerToChange === ON_STRIKE ? true : false, "isPlayInEvent": true,
                            [updateOrderKey]: player[updateOrderKey] || fetchNextPlayerOrder(playerToChange, prevValue[teamType], player?.currentInnings)
                        }
                        updatedOnPitchPlayer[playerToChange] = updatedPlayer
                        return updatedPlayer
                    }
                    else if (!isEqual(player.commentaryPlayerId, secondPitchPlayerId) && (player.isPlay || player.onStrike)) {
                        const playerToUpdate = { ...player, "isPlay": null, "onStrike": null }
                        allPlayersToUpdate.push(playerToUpdate)
                        return playerToUpdate
                    }
                    return player
                })
            }
        })
        setOnPitchPlayers(updatedOnPitchPlayer)
        // console.log("players at player change", players)
        // console.log("allPlayersToUpdate", allPlayersToUpdate, "playerUpdateList", playerUpdateList, "updatedOnPitchPlayer", updatedOnPitchPlayer);
        setPlayerUpdateList([].concat(allPlayersToUpdate, playerUpdateList || []))
        if (playerToChange === CURRENT_BOWLER) {
            setIsOverChange(true)
            if (overTypeToChange) setSelectedOverType(overTypeToChange)
        }
        if (isWicketChange) {
            // console.log("isWicketChange currentPartnership", currentPartnership)
            const currentBallDetails = { ...currentBall }
            currentBallDetails["nextBatStrikeId"] = updatedOnPitchPlayer[ON_STRIKE]?.commentaryPlayerId
            currentBallDetails["nextBatNonStrikeId"] = updatedOnPitchPlayer[NON_STRIKE]?.commentaryPlayerId
            const partnershipDetails = {
                "batter1Id": updatedOnPitchPlayer[ON_STRIKE]?.commentaryPlayerId,
                "batter1Name": updatedOnPitchPlayer[ON_STRIKE]?.playerName,
                "batter2Id": updatedOnPitchPlayer[NON_STRIKE]?.commentaryPlayerId,
                "batter2Name": updatedOnPitchPlayer[NON_STRIKE]?.playerName,
                "order": teams?.[BATTING_TEAM]?.teamWicket,
                // "order": currentPartnership.order + 1,
                "isActive": true,
                "commentaryBallByBallId": (currentBall.commentaryBallByBallId || "0"),

            }
            const updatedPartnership = generatePartnership({ commentaryDetails, currentPartnership: partnershipDetails, teams, onPitchPlayers: (isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers) })
            const objToSave = {
                "commentaryId": commentaryDetails.commentaryId,
                "isCallPredict": props?.isPredictToggle,
                "commentaryPartnership": updatedPartnership,
                "commentaryDetails": { ...commentaryDetails, "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : "" },
                "commentaryPlayers": [].concat(allPlayersToUpdate, Object.values(updatedOnPitchPlayer)),
                "commentaryBallByBall": currentBallDetails
            }
            checkForOverSwitch()
            // console.log("Called from : 9");
            // console.log("wicket", objToSave)
            // console.log("wicket partnership", objToSave.commentaryPartnership)
            dispatch(addCommentaryScreenData(objToSave))
            setIsWicketChange(undefined)
            setCurrentPartnership({})
        }
        setChangePlayerList(undefined)
        setPlayerToChange(undefined)
    }
    const changePlayer = (type) => {
        setPlayerToChange(type)
        setChangePlayerList(players[type === CURRENT_BOWLER ? BOWLING_TEAM : BATTING_TEAM]
            ?.filter((player) => {
                if (type === CURRENT_BOWLER)
                    return player.isPlay === null
                else return player.isPlay === null && player.isBatterOut !== true
            }))
    }
    const swapPlayer = (newPlayerId) => {
        const oldPlayer = onPitchPlayers[playerToChange] || {}
        const teamType = playerToChange === CURRENT_BOWLER ? BOWLING_TEAM : BATTING_TEAM
        let newPlayer = undefined
        players[teamType]?.forEach((player) => {
            if (isEqual(player.commentaryPlayerId, newPlayerId)) newPlayer = player
        })
        // let updatedNewPlayer = {
        //     ...newPlayer,
        //     "playerId": oldPlayer["playerId"],
        //     "playerName": oldPlayer["playerName"],
        //     "batsmanAverage": oldPlayer["batsmanAverage"],
        //     "bowlerAverage": oldPlayer["bowlerAverage"],
        //     "batterOrder": null,
        //     "bowlerOrder": null,
        // }
        // let updatedOldPlayer = {
        //     ...oldPlayer,
        //     "playerId": newPlayer["playerId"],
        //     "playerName": newPlayer["playerName"],
        //     "batsmanAverage": newPlayer["batsmanAverage"],
        //     "bowlerAverage": newPlayer["bowlerAverage"],
        //     "batterOrder": newPlayer["batterOrder"],
        //     "bowlerOrder": newPlayer["bowlerOrder"],
        // }
        let updatedNewPlayer = {}
        let updatedOldPlayer = {}
        if (oldPlayer?.batBall || oldPlayer?.batRun) {
            updatedNewPlayer = {
                ...newPlayer,
                "playerId": oldPlayer["playerId"],
                "playerName": oldPlayer["playerName"],
                "jerseyPlayerImage": oldPlayer["jerseyPlayerImage"],
                "jerseyPlayerImagePath": oldPlayer["jerseyPlayerImagePath"],
                "playerimage": oldPlayer["playerimage"],
                "batsmanAverage": oldPlayer["batsmanAverage"],
                "bowlerAverage": oldPlayer["bowlerAverage"],
                "bowlingStyle": oldPlayer["bowlingStyle"],
                "batterOrder": newPlayer["batterOrder"],
                "bowlerOrder": newPlayer["bowlerOrder"],
            }
            updatedOldPlayer = {
                ...oldPlayer,
                "playerId": newPlayer["playerId"],
                "playerName": newPlayer["playerName"],
                "jerseyPlayerImage": newPlayer["jerseyPlayerImage"],
                "jerseyPlayerImagePath": newPlayer["jerseyPlayerImagePath"],
                "playerimage": newPlayer["playerimage"],
                "batsmanAverage": newPlayer["batsmanAverage"],
                "bowlerAverage": newPlayer["bowlerAverage"],
                "bowlingStyle": newPlayer["bowlingStyle"],
                "batterOrder": oldPlayer["batterOrder"],
                "bowlerOrder": oldPlayer["bowlerOrder"],
            }
        } else {
            updatedNewPlayer = {
                ...oldPlayer,
                "batterOrder": newPlayer?.batterOrder,
                "bowlerOrder": newPlayer?.bowlerOrder,
                "isPlay": newPlayer?.isPlay,
                "onStrike": newPlayer?.onStrike,
                "isPlayInEvent": newPlayer?.isPlayInEvent,
            }
            updatedOldPlayer = {
                ...newPlayer,
                "batterOrder": oldPlayer?.batterOrder,
                "bowlerOrder": oldPlayer?.bowlerOrder,
                "isPlay": oldPlayer?.isPlay,
                "onStrike": oldPlayer?.onStrike,
                "isPlayInEvent": oldPlayer?.isPlayInEvent,
            }
        }

        const listToUpdate = players[teamType]?.map((player) => {
            if (isEqual(player.commentaryPlayerId, oldPlayer.commentaryPlayerId)) return updatedOldPlayer
            else if (isEqual(player.commentaryPlayerId, newPlayer.commentaryPlayerId)) return updatedNewPlayer
            return player
        })
        const updatedOnPitchPlayer = { ...onPitchPlayers, [playerToChange]: updatedOldPlayer }
        setOnPitchPlayers(updatedOnPitchPlayer)
        updatedOnPitchPlayer["EXTRA_PLAYER"] = updatedNewPlayer
        const objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryPlayers": Object.values(updatedOnPitchPlayer),
            "commentaryDetails": {
                ...commentaryDetails,
                "displayStatus": "Batter Switched",
                "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : ""
            }
        }
        if (currentPartnership?.commentaryPartnershipId && +currentPartnership?.commentaryPartnershipId != 0) {
            const updatedPartnership = {
                ...currentPartnership,
                batter1Name: updatedOnPitchPlayer?.[ON_STRIKE]?.playerName,
                batter1Id: updatedOnPitchPlayer?.[ON_STRIKE]?.commentaryPlayerId,
                batter2Name: updatedOnPitchPlayer?.[NON_STRIKE]?.playerName,
                batter2Id: updatedOnPitchPlayer?.[NON_STRIKE]?.commentaryPlayerId,
            }
            objToSave["commentaryPartnership"] = updatedPartnership
            _setCurrentPartnership(updatedPartnership)
        }
        // console.log("Called from : 10")
        dispatch(addCommentaryScreenData(objToSave))
        setPlayers({ ...players, [teamType]: listToUpdate })
        setIsSwapPlayer(undefined)
        setChangePlayerList(undefined)
        setPlayerToChange(undefined)
    }
    const switchBowler = (newPlayerId) => {
        const currentBowler = onPitchPlayers[CURRENT_BOWLER]
        let newBowler = undefined
        players[BOWLING_TEAM]?.forEach((player) => {
            if (isEqual(player.commentaryPlayerId, newPlayerId)) newBowler = player
        })
        const currentBowlerRemainingOver = +(currentBowler.bowlerOver || 0) - +(currentOver.ballCount / 10)
        let currentBowlerOrder = currentBowler.bowlerOrder
        let newBowlerOrder = newBowler.bowlerOrder
        const newOrder = fetchNextPlayerOrder(CURRENT_BOWLER, players[BOWLING_TEAM])
        if (!newBowlerOrder) {
            newBowlerOrder = newOrder
        }
        if (!currentBowlerRemainingOver || +currentBowlerRemainingOver === 0) {
            currentBowlerOrder = null
        }

        const updatedPerviousBowler = {
            ...currentBowler,
            "bowlerOver": currentBowlerRemainingOver,
            "bowlerTotalBall": +currentBowler.bowlerTotalBall - +currentOver.ballCount,
            "bowlerRun": +currentBowler.bowlerRun - getBowlerOnlyRuns(currentOver),
            "bowlerEconomy": getEconomyRate(+currentBowler.bowlerRun - getBowlerOnlyRuns(currentOver), +currentBowler.bowlerTotalBall - +currentOver.ballCount, matchTypeDetails.ballsPerOver),
            "bowlerDotBall": +currentBowler.bowlerDotBall - +currentOver.dotBall,
            "bowlerFour": +currentBowler.bowlerFour - +currentOver.totalFour,
            "bowlerSix": +currentBowler.bowlerSix - +currentOver.totalSix,
            "bowlerWideBall": +currentBowler.bowlerWideBall - +currentOver.totalWideBall,
            "bowlerNoBall": +currentBowler.bowlerNoBall - +currentOver.totalNoball,
            "bowlerWideBallRun": +currentBowler.bowlerWideBallRun - +currentOver.totalWideRun,
            "bowlerNoBallRun": +currentBowler.bowlerNoBallRun - +currentOver.totalNoBallRun,
            "bowlerByeBallRun": +currentBowler.bowlerByeBallRun - +currentOver.totalByesRun,
            "bowlerLegByeBallRun": +currentBowler.bowlerLegByeBallRun - +currentOver.totalLegByesRun,
            "bowlerTotalWicket": +currentBowler.bowlerTotalWicket - getBowlerRelatedWickets(currentOver?.overId, ballHistory),
            "bowlerOrder": currentBowlerOrder,
            "isPlay": null
        }
        const updatedNewBowler = {
            ...newBowler,
            "bowlerOver": +(newBowler.bowlerOver || 0) + +(currentOver.ballCount / 10),
            "bowlerTotalBall": +(newBowler.bowlerTotalBall || 0) + +(currentOver.ballCount || 0),
            "bowlerRun": +(newBowler.bowlerRun || 0) + getBowlerOnlyRuns(currentOver),
            "bowlerEconomy": getEconomyRate(getBowlerOnlyRuns(currentOver), +currentOver.ballCount, matchTypeDetails.ballsPerOver),
            "bowlerDotBall": +(newBowler.bowlerDotBall || 0) + +(currentOver.dotBall || 0),
            "bowlerFour": +(newBowler.bowlerFour || 0) + +(currentOver.totalFour || 0),
            "bowlerSix": +(newBowler.bowlerSix || 0) + +(currentOver.totalSix || 0),
            "bowlerWideBall": +(newBowler.bowlerWideBall || 0) + +(currentOver.totalWideBall || 0),
            "bowlerNoBall": +(newBowler.bowlerNoBall || 0) + +(currentOver.totalNoball || 0),
            "bowlerWideBallRun": +(newBowler.bowlerWideBallRun || 0) + +(currentOver.totalWideRun || 0),
            "bowlerNoBallRun": +(newBowler.bowlerNoBallRun || 0) + +(currentOver.totalNoBallRun || 0),
            "bowlerByeBallRun": +(newBowler.bowlerByeBallRun || 0) + +(currentOver.totalByesRun || 0),
            "bowlerLegByeBallRun": +(newBowler.bowlerLegByeBallRun || 0) + +(currentOver.totalLegByesRun || 0),
            "bowlerTotalWicket": +(newBowler.bowlerTotalWicket || 0) + getBowlerRelatedWickets(currentOver?.overId, ballHistory),
            "bowlerOrder": newBowlerOrder,
            "isPlay": true,
            "isPlayInEvent": true,
        }
        const UpdatedOver = {
            ...currentOver,
            "bowlerId": newPlayerId
        }
        const updatedPlayerList = players[BOWLING_TEAM].map(player => {
            if (isEqual(player.commentaryPlayerId, currentBowler.commentaryPlayerId)) return updatedPerviousBowler
            else if (isEqual(player.commentaryPlayerId, newBowler.commentaryPlayerId)) return updatedNewBowler
            else return player
        })
        const objForChangeBowler = {
            "commentaryId": commentaryDetails.commentaryId,
            "bowlerId": newPlayerId,
            "currentInnings": commentaryDetails.currentInnings,
            "overId": currentOver.overId
        }
        const objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryPlayers": [updatedPerviousBowler, updatedNewBowler],
        }
        // console.log("Called from : 12")
        dispatch(addCommentaryScreenData(objToSave))
        dispatch(changeBowlerFromCommentary(objForChangeBowler))
        setCurrentOver(UpdatedOver)
        setPlayers({ ...players, [BOWLING_TEAM]: updatedPlayerList })
        setOnPitchPlayers({ ...onPitchPlayers, [CURRENT_BOWLER]: updatedNewBowler })
        setChangePlayerList(undefined)
        setPlayerToChange(undefined)
        setIsChangeBowler({ isChange: null, isChangePopup: null, popupOption: null })
    }
    const sameOverNewBaller = (newPlayerId) => {
        const playersToChangeList = []
        const updateBall = {
            "commentaryBallByBallId": "0",
            "ballIsCount": false,
            "ballRun": 0,
            "ballExtraRun": 0,
            "bowlerId": onPitchPlayers[CURRENT_BOWLER]?.commentaryPlayerId,
            "batStrikeId": onPitchPlayers[ON_STRIKE]?.commentaryPlayerId,
            "batNonStrikeId": onPitchPlayers[NON_STRIKE]?.commentaryPlayerId,
            "ballType": BALL_TYPE_BOWLER_RETIRED_HURT
        }
        let updatedOnPitchPlayer = onPitchPlayers
        const updatedPlayerList = players[BOWLING_TEAM]?.map(player => {
            const updatedPlayer = player
            if (player.isPlay || player.onStrike) {
                updatedPlayer["isPlay"] = null
                updatedPlayer["onStrike"] = null
                playersToChangeList.push(updatedPlayer)
            }
            if (updatedPlayer.commentaryPlayerId === newPlayerId) {
                updatedPlayer["isPlay"] = true
                updatedPlayer["isPlayInEvent"] = true
                playersToChangeList.push(updatedPlayer)
                updatedOnPitchPlayer[CURRENT_BOWLER] = updatedPlayer
            }
            return updatedPlayer
        })
        const generatedBallByBall = generateBall({ currentBall: updateBall, commentaryDetails, currentOver, onPitchPlayers: { ...onPitchPlayers }, teams, currentPartnership })
        const objToSave = {
            "commentaryBallByBall": generatedBallByBall,
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryPlayers": playersToChangeList,
        }
        // console.log("Called from : 13")
        dispatch(addCommentaryScreenData(objToSave))
        setCurrentBall(updateBall)
        setPlayers({ ...players, [BOWLING_TEAM]: updatedPlayerList })
        setOnPitchPlayers(updatedOnPitchPlayer)
        setChangePlayerList(undefined)
        setPlayerToChange(undefined)
        setIsChangeBowler({ isChange: null, isChangePopup: null, popupOption: null })
    }
    const isPlayerNew = (player) => {
        const isStatZeroOrFalsy = (value) => {
            return !value || value == 0;
        };
        return (
            isStatZeroOrFalsy(player?.bowlerRun) &&
            isStatZeroOrFalsy(player?.batBall) &&
            isStatZeroOrFalsy(player?.batRun)
        );
    };
    const undoSameOverNewBaller = () => {
        const playersToChangeList = []
        let updatedOnPitchPlayer = onPitchPlayers
        const updatedPlayerList = players[BOWLING_TEAM]?.map(player => {
            const updatedPlayer = player
            if (player.isPlay || player.onStrike) {
                updatedPlayer["isPlay"] = null
                updatedPlayer["onStrike"] = null
                if (isPlayerNew(player)) {
                    updatedPlayer["isPlayInEvent"] = false;
                }
                playersToChangeList.push(updatedPlayer)
            }
            if (updatedPlayer.commentaryPlayerId === currentBall.bowlerId) {
                updatedPlayer["isPlay"] = true
                updatedPlayer["isPlayInEvent"] = true
                playersToChangeList.push(updatedPlayer)
                updatedOnPitchPlayer[CURRENT_BOWLER] = updatedPlayer
            }
            return updatedPlayer
        })
        const objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryPlayers": playersToChangeList,
            "deleteCommentaryBallByBallId": currentBall.commentaryBallByBallId
        }
        // console.log("Called from : 14")
        dispatch(addCommentaryScreenData(objToSave))
        setPlayers({ ...players, [BOWLING_TEAM]: updatedPlayerList })
        setOnPitchPlayers(updatedOnPitchPlayer)
    }
    const onBowlerChange = (newPlayerId) => {
        if (isChangeBowler.popupOption === SWITCH_BOWLER) switchBowler(newPlayerId)
        else if (isChangeBowler.popupOption === CHANGE_BOWLER) sameOverNewBaller(newPlayerId)
    }
    const changeOnStrikePlayer = (commentaryPlayerId) => {
        const isPlayerOnNonstrike = compareNumStringValues(onPitchPlayers[NON_STRIKE].commentaryPlayerId, commentaryPlayerId);
        if (isPlayerOnNonstrike) {
            const updatedOnStrikePlayer = { ...onPitchPlayers[NON_STRIKE], onStrike: true }
            const updatedNonStrikePlayer = { ...onPitchPlayers[ON_STRIKE], onStrike: false }
            setOnPitchPlayers({ ...onPitchPlayers, [ON_STRIKE]: updatedOnStrikePlayer, [NON_STRIKE]: updatedNonStrikePlayer })
            const objToSave = {
                "commentaryId": commentaryDetails.commentaryId,
                "commentaryDetails": { ...commentaryDetails, "displayStatus": `${updatedOnStrikePlayer.playerName} on Strike`, "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : "" },
                "isCallPredict": props?.isPredictToggle,
                "commentaryDetails": { ...commentaryDetails, "displayStatus": `${updatedOnStrikePlayer.playerName} on Strike`, "rmk": isRemainingBallsShow ? generateRemainingRuns(_teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : "" },
                "commentaryBallByBall": generateBall({
                    currentBall, commentaryDetails, currentOver,
                    onPitchPlayers: { ...onPitchPlayers, [ON_STRIKE]: updatedOnStrikePlayer, [NON_STRIKE]: updatedNonStrikePlayer }, teams,
                    currentPartnership
                }),
                "commentaryPlayers": [updatedOnStrikePlayer, updatedNonStrikePlayer, onPitchPlayers[CURRENT_BOWLER]]
            }
            // console.log("Called from : 15");
            dispatch(addCommentaryScreenData(objToSave))
        }
        setCurrentWicket(undefined)
    }
    const handleUndoClick = () => {
        // console.log("currentBall", currentBall)
        // console.log("teams[BATTING_TEAM]", teams[BATTING_TEAM])
        if (isSaving || isCommentaryBallLoading || !currentBall?.overCount || currentBall?.commentaryBallByBallId === lastUndoId) return;
        const syncTeam = isEmpty(_teams) ? teams : _teams;
        const syncOnPitchPlayers = isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers;
        const syncPlayers = isEmpty(_players) ? players : _players;
        const syncOver = isEmpty(_currentOver) ? currentOver : _currentOver;
        const syncPartnership = isEmpty(_currentPartnership) ? currentPartnership : _currentPartnership;
        
        if (currentBall?.commentaryBallByBallId && (+currentBall?.overCount === +syncTeam[BATTING_TEAM].teamOver)) {
            setLastUndoId(currentBall?.commentaryBallByBallId);

            // if (((currentOver.over || 0) === 0) && ((currentOver.ballCount || 0) === 0) && (currentBall.ballType === BALL_TYPE_OVER_COMPLETE)
            //     && ((currentBall.ballRun || 0) === 0) && ((currentBall.ballExtraRun || 0) === 0)) {
            //     setUndoInningsPopup(true)
            // } 

            if ((currentBall.ballType === BALL_TYPE_OVER_COMPLETE)
                && (currentBall.currentOverBalls === 0) && (currentBall.ballRun === 0) && (+currentBall?.overCount !== 0 )) setUndoOverPopup(true)
            else if (currentBall.ballType === BALL_TYPE_RETIRED_HURT) undoRetiredHurt()
            else if (currentBall.ballType === BALL_TYPE_BOWLER_RETIRED_HURT) undoSameOverNewBaller()
            else if (currentBall.ballType === BALL_TYPE_PANELTY_RUN) {
                const updateBattingTeam = syncTeam[BATTING_TEAM]
                const run = currentBall.ballExtraRun
                updateBattingTeam["teamScore"] = getNonNegativeValue((+syncTeam[BATTING_TEAM].teamScore || 0) - run)
                updateBattingTeam["teamPenaltyRuns"] = getNonNegativeValue((+syncTeam[BATTING_TEAM].teamPenaltyRuns || 0) - run)
                updateBattingTeam["crr"] = getRunRate(updateBattingTeam.teamScore, { ...syncOver }, matchTypeDetails.ballsPerOver)
                if (matchTypeDetails.isLimitedOvers && (target > 0)) {
                    updateBattingTeam["rrr"] = getRequiredRunRate(updateBattingTeam.teamScore,
                        syncOver, matchTypeDetails.ballsPerOver, target, syncTeam[BATTING_TEAM]?.teamMaxOver)
                }
                _setTeams({ ...syncTeam, [BATTING_TEAM]: updateBattingTeam })
                const objToSave = {
                    "commentaryId": commentaryDetails.commentaryId,
                    "isCallPredict": props?.isPredictToggle,
                    "commentaryTeams": [updateBattingTeam],
                    "deleteCommentaryBallByBallId": currentBall.commentaryBallByBallId
                }
                    // console.log("Called from : 16");
                setIsSaving(true);
                Promise.resolve(dispatch(addCommentaryScreenData(objToSave)))
                    .finally(() => {
                        setIsSaving(false);
                    });
                    // dispatch(addCommentaryScreenData(objToSave))
            }
            else {
                const isBallCount = currentBall.ballIsCount
                const updateBattingTeam = {}
                let updateBowler = {}
                let undoType = RUN
                const updateOver = {}
                let updatePartnership = { ...syncPartnership }
                let playersOnPitch = syncOnPitchPlayers
                if (currentBall.ballIsWicket) {
                    undoType = WICKET
                    updateOver["totalWicket"] = (syncOver.totalWicket || 0) - 1
                    updateBattingTeam["teamWicket"] = (syncTeam[BATTING_TEAM].teamWicket || 0) - 1
                    if (!LIST_TO_EXCLUDE_WICKET_FOR_BOWLER.includes(currentBall.ballWicketType))
                        updateBowler["bowlerTotalWicket"] = (syncOnPitchPlayers[CURRENT_BOWLER].bowlerTotalWicket || 0) - 1
                    updatePartnership = { ...partnershipHistory[partnershipHistory.length - 2], isActive: true }
                    playersOnPitch = updatePlayerAfterUndoWicket()
                }
                const bowler = playersOnPitch[CURRENT_BOWLER]
                const type = currentBall.ballType
                const isOnStrikeSame = compareNumStringValues(playersOnPitch[ON_STRIKE].commentaryPlayerId, currentBall.batStrikeId)
                const batter = isOnStrikeSame ? playersOnPitch[ON_STRIKE] : playersOnPitch[NON_STRIKE]
                const run = currentBall.ballRun
                const totalRun = currentBall.ballExtraRun + currentBall.ballRun
                const totalWideRun = currentBall?.ballExtraRun;
                let updateBatter = {}
                const updatedBowlerOver = isBallCount ? ((+bowler.bowlerOver || 0) - 0.1).toFixed(1) : +bowler.bowlerOver
                if (type === BALL_TYPE_REGULAR) {
                    if (isBallCount) {
                        updateBatter["batBall"] = (batter.batBall || 0) - (currentBall.ballIsCount ? 1 : 0)
                        updateBowler["bowlerTotalBall"] = (bowler.bowlerTotalBall || 0) - 1
                        updateOver["ballCount"] = (syncOver.ballCount || 0) - 1
                        updatePartnership["totalBalls"] = (updatePartnership?.totalBalls || 0) - 1
                        updatePartnership["batter1Balls"] = getNonNegativeValue((updatePartnership.batter1Balls || 0) -
                            (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter1Id) ? 1 : 0));
                        updatePartnership["batter2Balls"] = getNonNegativeValue((updatePartnership.batter2Balls || 0) -
                            (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter2Id) ? 1 : 0));
                        updateBowler["bowlerOver"] = updatedBowlerOver
                        updateBattingTeam["teamOver"] =
                            ((+syncTeam[BATTING_TEAM].teamOver || 0) - 0.1).toFixed(1)
                        if (run === 0) {
                            updateBatter["batDotBall"] = (batter.batDotBall || 0) - 1
                            updateOver["dotBall"] = (syncOver.dotBall || 0) - 1
                            updateBowler["bowlerDotBall"] = (bowler.bowlerDotBall || 0) - 1
                        }
                    }
                    updateBatter["batRun"] = getNonNegativeValue((batter.batRun || 0) - run)
                    updateBowler["bowlerRun"] = getNonNegativeValue((bowler.bowlerRun || 0) - run)
                    updatePartnership["totalRuns"] = getNonNegativeValue((updatePartnership?.totalRuns || 0) - run)
                    updatePartnership["batter1Runs"] = getNonNegativeValue((updatePartnership.batter1Runs || 0) -
                        (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter1Id) ? run : 0));
                    updatePartnership["batter2Runs"] = getNonNegativeValue((updatePartnership.batter2Runs || 0) -
                        (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter2Id) ? run : 0));
                    updateOver["totalRun"] = getNonNegativeValue((syncOver.totalRun || 0) - run)
                    updateBattingTeam["teamScore"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamScore || 0) - run)
                    if (matchTypeDetails.isLimitedOvers && (target > 0)) {
                        updateBattingTeam["rrr"] = getRequiredRunRate(updateBattingTeam.teamScore,
                            syncOver, matchTypeDetails.ballsPerOver, target, syncTeam[BATTING_TEAM]?.teamMaxOver)
                    }
                    if (currentBall.ballFour === 1 && currentBall.ballIsBoundry) {
                        updateBatter["batFour"] = getNonNegativeValue((batter.batFour || 0) - 1)
                        updateOver["totalFour"] = getNonNegativeValue((syncOver.totalFour || 0) - 1)
                        updatePartnership["totalFour"] = (syncPartnership.totalFour || 0) - 1
                        updateBowler["bowlerFour"] = getNonNegativeValue((bowler.bowlerFour || 0) - 1)

                    } else if (currentBall.ballSix === 1 && currentBall.ballIsBoundry) {
                        updateBatter["batSix"] = getNonNegativeValue((batter.batSix || 0) - 1)
                        updateOver["totalSix"] = getNonNegativeValue((syncOver.totalSix || 0) - 1)
                        updatePartnership["totalSix"] = (syncPartnership.totalSix || 0) - 1
                        updateBowler["bowlerSix"] = getNonNegativeValue((bowler.bowlerSix || 0) - 1)
                    }
                    updateBatter = { ...playersOnPitch[isOnStrikeSame ? ON_STRIKE : NON_STRIKE], ...updateBatter, onStrike: isOnStrikeSame ? false : true }
                    updateBowler = { ...playersOnPitch[CURRENT_BOWLER], ...updateBowler }
                    const updateNonStriker = { ...playersOnPitch[isOnStrikeSame ? NON_STRIKE : ON_STRIKE], onStrike: isOnStrikeSame ? true : false }
                    updateBattingTeam["crr"] = getRunRate(updateBattingTeam.teamScore, { ...syncOver, ...updateOver }, matchTypeDetails.ballsPerOver)
                    updateBowler["bowlerEconomy"] = getEconomyRate(updateBowler.bowlerRun, updateBowler.bowlerTotalBall, matchTypeDetails.ballsPerOver)
                    updateBowler["bowlerMaidenOver"] = 0
                    updateBatter["batsmanStrikeRate"] = getStrikeRate(updateBatter.batRun, updateBatter.batBall)
                    updateOver["isMaiden"] = false
                    _setOnPitchPlayers({ [ON_STRIKE]: updateBatter, [NON_STRIKE]: updateNonStriker, [CURRENT_BOWLER]: updateBowler })
                    _setPlayers((prevValue) => {
                        const actualPlayerValue = isEmpty(prevValue) ? syncPlayers : prevValue
                        return {
                            [BOWLING_TEAM]: actualPlayerValue?.[BOWLING_TEAM]?.map(player => compareNumStringValues(player.commentaryPlayerId, updateBowler.commentaryPlayerId) ? updateBowler : player),
                            [BATTING_TEAM]: actualPlayerValue?.[BATTING_TEAM]?.map(player => {
                                if (compareNumStringValues(player.commentaryPlayerId, updateBatter.commentaryPlayerId))
                                    return updateBatter
                                else if (compareNumStringValues(player.commentaryPlayerId, updateNonStriker.commentaryPlayerId))
                                    return updateNonStriker
                                else return player
                            })
                        }
                    })
                    _setCurrentPartnership({ ...syncPartnership, ...updatePartnership, })
                    _setTeams({ ...syncTeam, [BATTING_TEAM]: { ...syncTeam[BATTING_TEAM], ...updateBattingTeam } })
                    _setCurrentOver({ ...syncOver, ...updateOver, })
                } else {
                    if (type === BALL_TYPE_WIDE) {
                        updateBowler["bowlerWideBall"] = getNonNegativeValue((bowler.bowlerWideBall || 0) - 1)
                        updateBowler["bowlerWideBallRun"] = getNonNegativeValue((bowler.bowlerWideBallRun || 0) - totalWideRun)
                        updateBowler["bowlerRun"] = getNonNegativeValue((bowler.bowlerRun || 0) - totalWideRun)
                        updateBowler["bowlerEconomy"] = getEconomyRate(updateBowler.bowlerRun, bowler.bowlerTotalBall, matchTypeDetails.ballsPerOver)
                        updateBattingTeam["teamWideRuns"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamWideRuns || 0) - totalWideRun)
                        updateBattingTeam["teamScore"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamScore || 0) - totalWideRun)
                        updateOver["totalWideBall"] = getNonNegativeValue((syncOver.totalWideBall || 0) - 1)
                        updateOver["totalWideRun"] = getNonNegativeValue((syncOver.totalWideRun || 0) - totalWideRun)
                        updateOver["totalRun"] = getNonNegativeValue((syncOver.totalRun || 0) - totalWideRun)
                        updatePartnership["totalRuns"] = getNonNegativeValue(updatePartnership.totalRuns - totalWideRun)
                        updatePartnership["extras"] = getNonNegativeValue(updatePartnership.extras - totalWideRun)
                        updatePartnership["batter1Balls"] = updatePartnership.batter1Balls || 0;
                        updatePartnership["batter2Balls"] = updatePartnership.batter2Balls || 0;
                        updatePartnership["batter1Runs"] = updatePartnership.batter1Runs || 0;
                        updatePartnership["batter2Runs"] = updatePartnership.batter2Runs || 0;
                    } else if (type === BALL_TYPE_NO_BALL || type === BALL_TYPE_NO_BALL_BYE || type === BALL_TYPE_NO_BALL_LEG_BYE) {
                        const noBallValue = +currentBall.ballExtraRun
                        const UpdatedBallRun = +currentBall.ballRun
                        const totalRunToDelete = UpdatedBallRun + noBallValue
                        batter["batBall"] = getNonNegativeValue((batter.batBall || 0) - 1)
                        updateBowler["bowlerNoBall"] = getNonNegativeValue((bowler.bowlerNoBall || 0) - 1)
                        updateBowler["bowlerNoBallRun"] = getNonNegativeValue((bowler.bowlerNoBallRun || 0) - noBallValue)
                        updateBattingTeam["teamNoBallRuns"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamNoBallRuns || 0) - noBallValue)
                        updateBattingTeam["teamScore"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamScore || 0) - totalRun)
                        updateOver["totalNoball"] = getNonNegativeValue((syncOver.totalNoball || 0) - 1)
                        updateOver["totalNoBallRun"] = getNonNegativeValue((syncOver.totalNoBallRun || 0) - noBallValue)
                        updateOver["totalRun"] = getNonNegativeValue((syncOver.totalRun || 0) - totalRunToDelete)
                        updatePartnership["totalRuns"] = getNonNegativeValue(updatePartnership.totalRuns - totalRunToDelete)
                        updatePartnership["totalBalls"] = getNonNegativeValue(updatePartnership.totalBalls - 1)
                        updatePartnership["batter1Balls"] = getNonNegativeValue(syncPartnership.batter1Balls -
                            (compareNumStringValues(syncOnPitchPlayers[ON_STRIKE].commentaryPlayerId, syncPartnership.batter1Id) ? 1 : 0));
                        updatePartnership["batter2Balls"] = getNonNegativeValue(syncPartnership.batter2Balls -
                            (compareNumStringValues(syncOnPitchPlayers[ON_STRIKE].commentaryPlayerId, syncPartnership.batter2Id) ? 1 : 0));
                        updatePartnership["totalFour"] = getNonNegativeValue(syncPartnership.totalFour || 0) - 1
                        if (type === BALL_TYPE_NO_BALL) {
                            updateBowler["bowlerRun"] = getNonNegativeValue((bowler.bowlerRun || 0) - totalRunToDelete)
                            batter["batRun"] = getNonNegativeValue((batter.batRun || 0) - run)
                            updatePartnership["extras"] = getNonNegativeValue(updatePartnership.extras - noBallValue)
                            updatePartnership["batter1Runs"] = getNonNegativeValue((updatePartnership.batter1Runs || 0) -
                                (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter1Id) ? run : 0));
                            updatePartnership["batter2Runs"] = getNonNegativeValue((updatePartnership.batter2Runs || 0) -
                                (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter2Id) ? run : 0));
                        } else if (type === BALL_TYPE_NO_BALL_BYE) {
                            updateBowler["bowlerRun"] = getNonNegativeValue((bowler.bowlerRun || 0) - noBallValue)
                            updateBowler["bowlerByeBallRun"] = getNonNegativeValue((bowler.bowlerByeBallRun || 0) - UpdatedBallRun)
                            updateOver["totalByesRun"] = getNonNegativeValue((syncOver.totalByesRun || 0) - UpdatedBallRun)
                            updatePartnership["extras"] = getNonNegativeValue(updatePartnership.extras - totalRunToDelete)
                            updateBattingTeam["teamByRuns"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamByRuns || 0) - UpdatedBallRun)
                            updatePartnership["batter1Balls"] = getNonNegativeValue((updatePartnership.batter1Balls || 0) -
                                (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter1Id) ? 1 : 0));
                            updatePartnership["batter2Balls"] = getNonNegativeValue((updatePartnership.batter2Balls || 0) -
                                (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter2Id) ? 1 : 0));
                        }
                        else if (type === BALL_TYPE_NO_BALL_LEG_BYE) {
                            updateBowler["bowlerRun"] = getNonNegativeValue((bowler.bowlerRun || 0) - noBallValue)
                            updateBowler["bowlerNoBallRun"] = getNonNegativeValue((bowler.bowlerNoBallRun || 0) - UpdatedBallRun)
                            updateOver["totalLegByesRun"] = getNonNegativeValue((syncOver.totalNoBallRun || 0) - UpdatedBallRun)
                            updatePartnership["extras"] = getNonNegativeValue(updatePartnership.extras - totalRunToDelete)
                            updateBattingTeam["teamLegByRuns"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamLegByRuns || 0) - UpdatedBallRun)
                            updatePartnership["batter1Balls"] = getNonNegativeValue((updatePartnership.batter1Balls || 0) -
                                (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter1Id) ? 1 : 0));
                            updatePartnership["batter2Balls"] = getNonNegativeValue((updatePartnership.batter2Balls || 0) -
                                (compareNumStringValues(batter.commentaryPlayerId, syncPartnership.batter2Id) ? 1 : 0));
                        }
                    }
                    else {
                        batter["batBall"] = getNonNegativeValue((batter.batBall || 0) - 1)
                        updateBowler["bowlerOver"] = getNonNegativeValue(((+bowler.bowlerOver || 0) - 0.1).toFixed(1))
                        updateBattingTeam["teamOver"] = getNonNegativeValue(((+syncTeam[BATTING_TEAM].teamOver || 0) - 0.1).toFixed(1))
                        updateBowler["bowlerTotalBall"] = getNonNegativeValue((bowler.bowlerTotalBall || 0) - 1)
                        updateOver["ballCount"] = getNonNegativeValue((syncOver.ballCount || 0) - 1)
                        updateOver["totalRun"] = getNonNegativeValue((syncOver.totalRun || 0) - run)
                        updateBattingTeam["teamScore"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamScore || 0) - run)
                        updatePartnership["totalRuns"] = getNonNegativeValue(updatePartnership.totalRuns - run)
                        updatePartnership["extras"] = getNonNegativeValue(updatePartnership.extras - run)
                        updatePartnership["totalBalls"] = getNonNegativeValue(updatePartnership.totalBalls - 1)
                        if (type === BALL_TYPE_BYE) {
                            updateBowler["bowlerByeBall"] = getNonNegativeValue((bowler.bowlerByeBall || 0) - 1)
                            updateBowler["bowlerByeBallRun"] = getNonNegativeValue((bowler.bowlerByeBallRun || 0) - run)
                            updateOver["totalByesBall"] = getNonNegativeValue((syncOver.totalByesBall || 0) - 1)
                            updateOver["totalByesRun"] = getNonNegativeValue((syncOver.totalByesRun || 0) - run)
                            updateBattingTeam["teamByRuns"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamByRuns || 0) - run)
                        }
                        else if (type === BALL_TYPE_LEG_BYE) {
                            updateBowler["bowlerLegByeBall"] = getNonNegativeValue((bowler.bowlerLegByeBall || 0) - 1)
                            updateBowler["bowlerLegByeBallRun"] = getNonNegativeValue((bowler.bowlerLegByeBallRun || 0) - run)
                            updateOver["totalLegByesBall"] = getNonNegativeValue((syncOver.totalLegByesBall || 0) - 1)
                            updateOver["totalLegByesRun"] = getNonNegativeValue((syncOver.totalLegByesRun || 0) - run)
                            updateBattingTeam["teamLegByRuns"] = getNonNegativeValue((syncTeam[BATTING_TEAM].teamLegByRuns || 0) - run)
                        }
                    }
                    if (matchTypeDetails.isLimitedOvers && (target > 0)) {
                        updateBattingTeam["rrr"] = getRequiredRunRate(syncTeam[BATTING_TEAM].teamScore,
                            syncOver, matchTypeDetails.ballsPerOver, target, syncTeam[BATTING_TEAM]?.teamMaxOver)
                    }
                    updateBatter["batsmanStrikeRate"] = getStrikeRate(updateBatter.batRun, updateBatter.batBall)
                    updateBowler["bowlerEconomy"] = getEconomyRate(updateBowler.bowlerRun, updateBowler.totalBalls, matchTypeDetails.ballsPerOver)
                    updateBattingTeam["crr"] = getRunRate(updateBattingTeam.teamScore, { ...syncOver, ...updateOver }, matchTypeDetails.ballsPerOver)
                    updateBatter = { ...playersOnPitch[isOnStrikeSame ? ON_STRIKE : NON_STRIKE], ...updateBatter, onStrike: isOnStrikeSame ? true : false }
                    const updateNonStriker = { ...playersOnPitch[isOnStrikeSame ? NON_STRIKE : ON_STRIKE], onStrike: isOnStrikeSame ? false : true }
                    updateBowler = { ...syncOnPitchPlayers[CURRENT_BOWLER], ...updateBowler }
                    _setOnPitchPlayers({ [ON_STRIKE]: updateBatter, [NON_STRIKE]: updateNonStriker, [CURRENT_BOWLER]: updateBowler })
                    _setPlayers({
                        [BOWLING_TEAM]: syncPlayers?.[BOWLING_TEAM].map(player => compareNumStringValues(player.commentaryPlayerId, updateBowler.commentaryPlayerId) ? updateBowler : player),
                        [BATTING_TEAM]: syncPlayers?.[BATTING_TEAM].map(player => {
                            if (compareNumStringValues(player.commentaryPlayerId, updateBatter.commentaryPlayerId))
                                return updateBatter
                            else if (compareNumStringValues(player.commentaryPlayerId, updateNonStriker.commentaryPlayerId))
                                return updateNonStriker
                            else return player
                        })
                    })
                    _setTeams({ ...syncTeam, [BATTING_TEAM]: { ...syncTeam[BATTING_TEAM], ...updateBattingTeam } })
                    _setCurrentOver({ ...syncOver, ...updateOver })
                    _setCurrentPartnership({ ...syncPartnership, ...updatePartnership })
                }
                if (isBallCount) {
                    setBallCountForStrike(currentBall.autoStrikeBallCount || 0)
                }
                setIsUndoBall(undoType)
                setSaveToDb(true)
            }
        } else {
            // setUndoErrorModal(`OverCount in ball: ${+currentBall?.overCount} is not equal to teamOver : ${+teams[BATTING_TEAM].teamOver}. please correct it from update feature screen`)
            setIsSaving(true);
            setUndoErrorModal(`There is some data mismatched, Please click Retry.`)
        }
    }

    const onUndoLastInnings = async () => {
        try {

            //Identify current teams
            const currentBattingTeam = teams[BATTING_TEAM];
            const currentBowlingTeam = teams[BOWLING_TEAM];

            if (!currentBattingTeam || !currentBowlingTeam) {
                setUndoErrorModal("Unable to find both teams");
                return;
            }

            const sameInningsTeams = allInningaTeams.filter(
                t => t.currentInnings === commentaryDetails.currentInnings
            );
            const hasBattingCompleteInSameInnings = sameInningsTeams.some(t => t.isBattingComplete);

            //Determine scenario type
            const isMultiInnings = matchTypeDetails.noOfIningsPerSide > 1
                && !hasBattingCompleteInSameInnings;

            let deleteBallIds = [];
            let deleteOverIds = [];
            let deletePartnershipIds = [];
            // let deleteWickets = [];
            let updatedTeams = [];
            let updatedOnPitchPlayers = [];
            let restoredOver = [];
            let restoredPartnership = [];
            let ballToRestore = [];
            let battingTeamPlayers = []
            let bowlingTeamPlayers = []
            // ========== SCENARIO 1: SINGLE INNINGS ==========
            if (hasBattingCompleteInSameInnings) {
                const firstBattingTeam = currentBowlingTeam; // Team that batted first
                const secondBattingTeam = currentBattingTeam; // Team currently batting

                //Get first batting team's balls

                const firstTeamBalls = ballHistory.filter(ball =>
                    ball.currentInnings === commentaryDetails.currentInnings &&
                    compareNumStringValues(ball.teamId, firstBattingTeam.teamId)
                );

                // console.log("First team balls found:", firstTeamBalls);

                if (firstTeamBalls.length < 1) {
                    setUndoErrorModal("Not enough balls found for first batting team");
                    return;
                }

                // Restore the previous teams balls and playerIds
                ballToRestore = firstTeamBalls[firstTeamBalls.length - 1];
                const bowlToAdd = ((+ballToRestore.currentOverBalls || 0) / 10);
                //  console.log("ballToRestore", ballToRestore, "bowlToAdd", bowlToAdd)

                // Extract player IDs from ball to restore
                const bowlerId = ballToRestore.bowlerId;
                const batStrikeId = ballToRestore?.batStrikeId ? ballToRestore.batStrikeId : ballToRestore.nextBatStrikeId;
                const batNonStrikeId = ballToRestore?.batNonStrikeId ? ballToRestore.batNonStrikeId : ballToRestore.nextBatNonStrikeId;

                //Second teams first ball delete
                const secondTeamBalls = ballHistory.filter(b =>
                    b.currentInnings === commentaryDetails.currentInnings &&
                    compareNumStringValues(b.teamId, secondBattingTeam.teamId)
                );
                deleteBallIds.push(...secondTeamBalls.map(b => b.commentaryBallByBallId));

                //Get first batting team's last over

                const firstTeamOvers = overHistory.filter(over =>
                    over.currentInnings === commentaryDetails.currentInnings &&
                    compareNumStringValues(over.teamId, firstBattingTeam.teamId)
                );

                if (firstTeamOvers.length === 0) {
                    setUndoErrorModal("No overs found for first batting team");
                    return;
                }

                // Restored over
                const lastFirstTeamOver = firstTeamOvers[firstTeamOvers.length - 1];
                restoredOver = {
                    ...lastFirstTeamOver,
                    isComplete: false,
                };

                // Add all overs from second team
                const secondTeamOvers = overHistory.filter(o =>
                    o.currentInnings === commentaryDetails.currentInnings &&
                    compareNumStringValues(o.teamId, secondBattingTeam.teamId)
                );
                deleteOverIds = secondTeamOvers.map(o => o.overId);

                // const secondTeamWickets = wicketHistory.filter(w =>
                //     w.currentInnings === commentaryDetails.currentInnings &&
                //     compareNumStringValues(w.teamId, secondBattingTeam.teamId)
                // );
                // deleteWickets.push(...secondTeamWickets.map(w => w.commentaryWicketId));

                // Find partnership
                let firstTeamPartnerships = partnershipHistory.filter(partnership =>
                    partnership.currentInnings === commentaryDetails.currentInnings &&
                    compareNumStringValues(partnership.teamId, firstBattingTeam.teamId)
                );

                firstTeamPartnerships = Array.isArray(firstTeamPartnerships)
                    ? firstTeamPartnerships
                    : [firstTeamPartnerships];

                for (let i = firstTeamPartnerships.length - 1; i >= 0; i--) {
                    const p = firstTeamPartnerships[i];
                    if ((compareNumStringValues(p.batter1Id, batStrikeId) && compareNumStringValues(p.batter2Id, batNonStrikeId)) ||
                        (compareNumStringValues(p.batter1Id, batNonStrikeId) && compareNumStringValues(p.batter2Id, batStrikeId))) {
                        restoredPartnership = {
                            ...p,
                            isActive: true,
                        };
                        break;
                    }
                }

                // console.log("restored partnership", restoredPartnership)

                // Add all partnerships from second team
                const secondTeamPartnerships = partnershipHistory.filter(p =>
                    p.currentInnings === commentaryDetails.currentInnings &&
                    compareNumStringValues(p.teamId, secondBattingTeam.teamId)
                );
                deletePartnershipIds = secondTeamPartnerships.map(p => p.commentaryPartnershipId);

                // Find players for updatedOnPitchPlayers
                propsData.commentaryData.commentaryPlayers.forEach(player => {
                    if (compareNumStringValues(player.teamId, firstBattingTeam.teamId)) {
                        if (compareNumStringValues(player.commentaryPlayerId, batStrikeId)) {
                            updatedOnPitchPlayers[ON_STRIKE] = {
                                ...player,
                                isPlay: true,
                                onStrike: true
                            };
                        } else if (compareNumStringValues(player.commentaryPlayerId, batNonStrikeId)) {
                            updatedOnPitchPlayers[NON_STRIKE] = {
                                ...player,
                                isPlay: true,
                                onStrike: false
                            };
                        }
                    } else if (compareNumStringValues(player.teamId, secondBattingTeam.teamId)) {
                        if (compareNumStringValues(player.commentaryPlayerId, bowlerId)) {
                            updatedOnPitchPlayers[CURRENT_BOWLER] = {
                                ...player,
                                isPlay: true,
                            };
                        }
                    }
                });

                //Prepare team updates
                updatedTeams = [
                    {
                        ...firstBattingTeam,
                        teamStatus: BATTING_STATUS,
                        isBattingComplete: false,
                        teamOver: ballToRestore ? (+ballToRestore?.overCount)?.toFixed(1) : (((+firstBattingTeam.teamOver || 0) - 1) + bowlToAdd)?.toFixed(1),
                    },
                    {
                        ...secondBattingTeam,
                        teamStatus: BOWLING_STATUS,
                    }
                ];

            } else if (isMultiInnings) {

                const targetInnings = commentaryDetails.currentInnings - 1;

                // Find previous innings' last batting team
                let previousBattingTeam = null;
                let previousBowlingTeam = null;

                const previousInningsTeams = allInningaTeams.filter(
                    t => t.currentInnings === targetInnings
                );

                previousInningsTeams.sort(
                    (a, b) => Number(b.teamBattingOrder) - Number(a.teamBattingOrder)
                );

                previousBattingTeam = previousInningsTeams[0];
                previousBowlingTeam = previousInningsTeams[1];

                if (!previousBattingTeam || !previousBowlingTeam) {
                    setUndoErrorModal("Cannot find previous innings teams");
                    return;
                }

                // console.log("Previous batting team:", previousBattingTeam.shortName);
                // console.log("Previous bowling team:", previousBowlingTeam.shortName);

                // Get previous innings' balls
                const previousTeamBalls = ballHistory.filter(ball =>
                    ball.currentInnings === targetInnings &&
                    compareNumStringValues(ball.teamId, previousBattingTeam.teamId)
                );

                if (previousTeamBalls.length < 1) {
                    setUndoErrorModal("Not enough balls found in previous innings");
                    return;
                }

                //Ball to restore (second-to-last ball of previous innings)
                ballToRestore = previousTeamBalls[previousTeamBalls.length - 1];

                const bowlToAdd = ((+ballToRestore.currentOverBalls || 0) / 10);

                // Extract player IDs
                const bowlerId = ballToRestore.bowlerId;
                const batStrikeId = ballToRestore?.batStrikeId ? ballToRestore.batStrikeId : ballToRestore.nextBatStrikeId;
                const batNonStrikeId = ballToRestore?.batNonStrikeId ? ballToRestore.batNonStrikeId : ballToRestore.nextBatNonStrikeId;

                // Add ALL data from current innings
                const currentInningsBalls = ballHistory.filter(b =>
                    b.currentInnings === commentaryDetails.currentInnings
                );
                deleteBallIds.push(...currentInningsBalls.map(b => b.commentaryBallByBallId));

                const currentInningsOvers = overHistory.filter(o =>
                    o.currentInnings === commentaryDetails.currentInnings
                );
                deleteOverIds = currentInningsOvers.map(o => o.overId);

                const previousTeamOvers = overHistory.filter(over =>
                    over.currentInnings === targetInnings &&
                    compareNumStringValues(over.teamId, previousBattingTeam.teamId)
                );

                if (previousTeamOvers.length === 0) {
                    setUndoErrorModal("No overs found in previous innings");
                    return;
                }

                const lastPreviousTeamOver = previousTeamOvers[previousTeamOvers.length - 1];

                // Restored over
                restoredOver = {
                    ...lastPreviousTeamOver,
                    isComplete: false,
                };

                const currentInningsPartnerships = partnershipHistory.filter(p =>
                    p.currentInnings === commentaryDetails.currentInnings
                );
                deletePartnershipIds = currentInningsPartnerships.map(p => p.commentaryPartnershipId);

                //Find partnership
                let previousTeamPartnerships = partnershipHistory.filter(partnership =>
                    partnership.currentInnings === targetInnings &&
                    compareNumStringValues(partnership.teamId, previousBattingTeam.teamId)
                );

                previousTeamPartnerships = Array.isArray(previousTeamPartnerships)
                    ? previousTeamPartnerships
                    : [previousTeamPartnerships];

                for (let i = previousTeamPartnerships.length - 1; i >= 0; i--) {
                    const p = previousTeamPartnerships[i];
                    if ((compareNumStringValues(p.batter1Id, batStrikeId) && compareNumStringValues(p.batter2Id, batNonStrikeId)) ||
                        (compareNumStringValues(p.batter1Id, batNonStrikeId) && compareNumStringValues(p.batter2Id, batStrikeId))) {
                        restoredPartnership = {
                            ...p,
                            isActive: true,
                        };
                        break;
                    }
                }

                // const currentInningWickets = wicketHistory.filter(w =>
                //     w.currentInnings === commentaryDetails.currentInnings
                // );
                // deleteWickets.push(...currentInningWickets.map(w => w.commentaryWicketId));

                //Find players
                propsData.commentaryData.commentaryPlayers.forEach(player => {
                    if (compareNumStringValues(player.teamId, previousBattingTeam.teamId)) {
                        if (compareNumStringValues(player.commentaryPlayerId, batStrikeId)) {
                            updatedOnPitchPlayers[ON_STRIKE] = {
                                ...player,
                                isPlay: true,
                                onStrike: true
                            };
                        } else if (compareNumStringValues(player.commentaryPlayerId, batNonStrikeId)) {
                            updatedOnPitchPlayers[NON_STRIKE] = {
                                ...player,
                                isPlay: true,
                                onStrike: false
                            };
                        }
                    } else if (compareNumStringValues(player.teamId, previousBowlingTeam.teamId)) {
                        if (compareNumStringValues(player.commentaryPlayerId, bowlerId)) {
                            updatedOnPitchPlayers[CURRENT_BOWLER] = {
                                ...player,
                                isPlay: true,
                            };
                        }
                    }
                });

                // Prepare team updates
                updatedTeams = [
                    {
                        ...previousBattingTeam,
                        teamStatus: BATTING_STATUS,
                        isBattingComplete: false,
                        teamOver: ballToRestore ? (+ballToRestore?.overCount)?.toFixed(1) : (((+previousBattingTeam.teamOver || 0) - 1) + bowlToAdd)?.toFixed(1),
                    },
                    {
                        ...previousBowlingTeam,
                        teamStatus: BOWLING_STATUS,
                    }
                ];
            }
            else {
                setUndoErrorModal("Cannot undo innings: Invalid state. Match must be in a valid innings transition state.");
                return;
            }

            //Prepare players to reset (current on-pitch players)
            const playersToReset = [
                onPitchPlayers[ON_STRIKE],
                onPitchPlayers[NON_STRIKE],
                onPitchPlayers[CURRENT_BOWLER]
            ]
                .filter(p => p?.commentaryPlayerId) // Filter out null/undefined
                .map(p => ({
                    ...p,
                    isPlay: null,
                    onStrike: null
                }));

            const innings = isMultiInnings ? commentaryDetails?.currentInnings - 1 : commentaryDetails?.currentInnings;
            //Prepare API payload
            const payload = {
                commentaryId: commentaryDetails.commentaryId,
                deleteCommentaryBallByBallId: deleteBallIds,
                deleteOverId: deleteOverIds,
                // deleteWicketId: deleteWickets,
                deletePartnershipId: deletePartnershipIds,
                commentaryPlayers: [...playersToReset, ...Object.values(updatedOnPitchPlayers)],
                commentaryDetails: {
                    ...commentaryDetails,
                    currentInnings: innings,
                    commentaryStatus: 3,
                },
                commentaryTeams: updatedTeams,
                commentaryOvers: restoredOver,
                commentaryPartnership: restoredPartnership,
            };

            // console.log("\n=== API PAYLOAD ===");
            // console.log("Teams to update:", updatedTeams);
            // console.log("Balls to delete:", deleteBallIds);
            // console.log("Overs to delete:", deleteOverIds);
            // console.log("Partnerships to delete:", deletePartnershipIds);
            // console.log("wickets to delete", deleteWickets)
            // console.log("Players to reset:", playersToReset, onPitchPlayers);

            // Step 7: Call API
            await axiosInstance.post('/admin/commentary/undoDetails', payload)
                .then((response) => {
                    setUndoInningsPopup(undefined);

                    setCommentaryDetails((prev) => ({
                        ...prev,
                        currentInnings: innings,
                        commentaryStatus: 3,
                    }))

                    setTeams({
                        [BATTING_TEAM]: updatedTeams[0],
                        [BOWLING_TEAM]: updatedTeams[1]
                    });

                    propsData.commentaryData.commentaryPlayers.forEach(playerDetails => {
                        // if (isEqual(playerDetails.currentInnings, commentaryDetails.currentInnings)) {
                        const isBattingTeam = playerDetails?.teamId === updatedTeams[0]?.teamId
                        // If player is from batting team, add them to the batting object list
                        if (isBattingTeam) {
                            battingTeamPlayers.push(playerDetails)
                        }
                        else {
                            bowlingTeamPlayers.push(playerDetails)
                        }
                    });

                    setPlayers({
                        [BATTING_TEAM]: battingTeamPlayers,
                        [BOWLING_TEAM]: bowlingTeamPlayers
                    })
                    setOnPitchPlayers(updatedOnPitchPlayers);
                    setCurrentOver(restoredOver);
                    setCurrentPartnership(restoredPartnership);
                    setIsLastInnings(false);

                    // Remove deleted items from local history
                    // if (deleteWickets.length > 0) {
                    //     const updatedWicketHistory = wicketHistory.filter(w =>
                    //         !deleteWickets.includes(w.commentaryWicketId)
                    //     );
                    //     setWicketHistory(updatedWicketHistory);
                    // }
                    if (deleteBallIds.length > 0) {
                        const updatedBalls = ballHistory.filter(b =>
                            !deleteBallIds.includes(b.commentaryBallByBallId)
                        );
                        setBallHistory(updatedBalls);
                    }
                    if (deleteOverIds.length > 0) {
                        let updatedOvers = (Array.isArray(overHistory) ? overHistory : [])
                            .filter(o => !deleteOverIds.includes(o.overId));

                        if (restoredOver) {
                            const i = updatedOvers.findIndex(o =>
                                compareNumStringValues(o.overId, restoredOver.overId)
                            );
                            i !== -1 ? (updatedOvers[i] = restoredOver) : updatedOvers.push(restoredOver);
                        }
                        setOverHistory(updatedOvers);
                    }

                    if (deletePartnershipIds.length > 0) {
                        let updatedpartnership = (Array.isArray(partnershipHistory) ? partnershipHistory : [])
                            .filter(p => !deletePartnershipIds.includes(p.commentaryPartnershipId));

                        if (restoredPartnership) {
                            const i = updatedpartnership.findIndex(p =>
                                compareNumStringValues(p.commentaryPartnershipId, restoredPartnership.commentaryPartnershipId)
                            );
                            i !== -1 ? (updatedpartnership[i] = restoredPartnership) : updatedpartnership.push(restoredPartnership);
                        }

                        setPartnershipHistory(updatedpartnership);
                    }
                    setCurrentBall(ballToRestore);
                    setIsInningsUndoDone(true);

                    // Show success message
                    dispatch(
                        updateToastData({
                            data: response?.data?.message || "Innings undo successful",
                            title: "Success",
                            type: SUCCESS,
                        })
                    );

                    // Refresh data
                    props.fetchData();
                    setRedirectOnScreenChange(true);
                })
                .catch((error) => {
                    setUndoErrorModal(
                        error?.response?.data?.message ||
                        error?.message ||
                        "Failed to undo innings"
                    );
                });

        } catch (error) {
            console.error("=== ERROR IN UNDO INNINGS ===");
            console.error("Error:", error);
            console.error("Stack:", error.stack);
            setUndoErrorModal("An error occurred while undoing innings: " + error.message);
            setIsInningsUndoDone(false);
        } finally {
            setUndoInningsPopup(false);
        }
    };

    useEffect(() => {
        if (isInningsUndoDone && currentBall && !isCommentaryBallLoading && !isSaving) {
            // console.log("Ball to undo:", {
            //     id: currentBall.commentaryBallByBallId,
            //     overCount: currentBall.overCount,
            //     ballType: currentBall.ballType,
            //     teamOver: teams[BATTING_TEAM]?.teamOver
            // });
            setShowChangeOverModal(false);
            // console.log("Current ball after setState:", currentBall?.commentaryBallByBallId);
            handleUndoClick();
            setIsInningsUndoDone(null);
        }
    }, [isInningsUndoDone, currentBall, isCommentaryBallLoading, isSaving]);

    const updatePlayerAfterUndoWicket = () => {
        const isbatterWicket = (player) => {
            const updatedPlayerToSend = {}
            if (player.isBatterOut) {
                updatedPlayerToSend["isBatterOut"] = null
                updatedPlayerToSend["bowlerId"] = "0"
                updatedPlayerToSend["fielderId1"] = "0"
                updatedPlayerToSend["fielderId2"] = "0"
                updatedPlayerToSend["wicketType"] = null
                // updatedPlayerToSend["batterOrder"] = null
            }
            return updatedPlayerToSend
        }
        const updatedOnPitchPlayer = {}
        const playerListToSendToDb = []
        const updatedBattingPlayerList = players[BATTING_TEAM].map(player => {
            let forNewPlayers = {}
            if (compareNumStringValues(player.commentaryPlayerId, onPitchPlayers[ON_STRIKE].commentaryPlayerId)
                || compareNumStringValues(player.commentaryPlayerId, onPitchPlayers[NON_STRIKE].commentaryPlayerId)) {
                forNewPlayers = { isPlay: null, onStrike: null, isBatterOut: null, batterOrder: null, batsmanStrikeRate: null, bowlerEconomy: null, isPlayInEvent: isPlayerNew(player) ? false : player?.isPlayInEvent }
                playerListToSendToDb.push({ ...player, ...forNewPlayers })
            }
            let updatedPlayer = { ...player, ...forNewPlayers }
            let wicketDetails = {}
            if (compareNumStringValues(player.commentaryPlayerId, currentBall.batStrikeId)) {
                wicketDetails = isbatterWicket(player)
                updatedPlayer = { ...updatedPlayer, ...wicketDetails, isPlay: true, onStrike: true }
                if (compareNumStringValues(player.commentaryPlayerId, onPitchPlayers[ON_STRIKE].commentaryPlayerId)) updatedPlayer["batterOrder"] = onPitchPlayers[ON_STRIKE].batterOrder
                if (compareNumStringValues(player.commentaryPlayerId, onPitchPlayers[NON_STRIKE].commentaryPlayerId)) updatedPlayer["batterOrder"] = onPitchPlayers[NON_STRIKE].batterOrder
                updatedOnPitchPlayer[ON_STRIKE] = updatedPlayer
            }
            else if (compareNumStringValues(player.commentaryPlayerId, currentBall.batNonStrikeId)) {
                wicketDetails = isbatterWicket(player)
                updatedPlayer = { ...updatedPlayer, ...wicketDetails, isPlay: true, onStrike: false }
                if (compareNumStringValues(player.commentaryPlayerId, onPitchPlayers[ON_STRIKE].commentaryPlayerId)) updatedPlayer["batterOrder"] = onPitchPlayers[ON_STRIKE].batterOrder
                if (compareNumStringValues(player.commentaryPlayerId, onPitchPlayers[NON_STRIKE].commentaryPlayerId)) updatedPlayer["batterOrder"] = onPitchPlayers[NON_STRIKE].batterOrder
                updatedOnPitchPlayer[NON_STRIKE] = updatedPlayer
            }
            return updatedPlayer
        })
        _setPlayers({ ...players, [BATTING_TEAM]: updatedBattingPlayerList })
        updatedOnPitchPlayer[CURRENT_BOWLER] = onPitchPlayers[CURRENT_BOWLER]
        setPlayerUpdateList([].concat(playerListToSendToDb, playerUpdateList || []))
        return updatedOnPitchPlayer
    }

    const updateAfterOverUndo = () => {
        // console.log("inside here");
        setIsUndoingLastOver(true);
        // removing 2 becaus length and index difference
        const previousBall = ballHistory[ballHistory.length - 2]
        const previousOnPitchPlayer = {}
        const updatedBattingTeam = teams[BATTING_TEAM]
        const updatedBowlingPlayerList = players[BOWLING_TEAM].map(player => {
            const updatedPlayer = player
            if (compareNumStringValues(player.commentaryPlayerId, onPitchPlayers[CURRENT_BOWLER].commentaryPlayerId)) {
                updatedPlayer["isPlay"] = null
                if (isPlayerNew(player)) {
                    updatedPlayer["isPlayInEvent"] = false;
                    updatedPlayer["bowlerOrder"] = null;
                }
                setPlayerUpdateList([].concat([updatedPlayer], playerUpdateList || []))
            }
            else if (compareNumStringValues(player.commentaryPlayerId, previousBall.bowlerId)) {
                updatedPlayer["isPlay"] = true
                const bowlToAdd = ((+previousBall.currentOverBalls || 0) / 10)
                updatedPlayer["bowlerOver"] = (((+player.bowlerOver || 0) - 1) + bowlToAdd)?.toFixed(1)
                updatedBattingTeam["teamOver"] = (((+updatedBattingTeam.teamOver || 0) - 1) + bowlToAdd)?.toFixed(1)
                previousOnPitchPlayer[CURRENT_BOWLER] = updatedPlayer
            }
            return updatedPlayer
        })
        const updatedBattingPlayerList = players[BATTING_TEAM].map(player => {
            const updatedPlayer = player
            if (compareNumStringValues(player.commentaryPlayerId, onPitchPlayers[ON_STRIKE].commentaryPlayerId) ||
                compareNumStringValues(player.commentaryPlayerId, onPitchPlayers[NON_STRIKE].commentaryPlayerId)) {
                updatedPlayer["isPlay"] = null
                updatedPlayer["onStrike"] = null
                if (isPlayerNew(player)) {
                    updatedPlayer["isPlayInEvent"] = false;
                }
            }
            if (compareNumStringValues(player.commentaryPlayerId, previousBall.nextBatStrikeId)) {
                updatedPlayer["isPlay"] = true
                updatedPlayer["onStrike"] = true
                previousOnPitchPlayer[ON_STRIKE] = updatedPlayer
            }
            if (compareNumStringValues(player.commentaryPlayerId, previousBall.nextBatNonStrikeId)) {
                updatedPlayer["isPlay"] = true
                previousOnPitchPlayer[NON_STRIKE] = updatedPlayer
            }
            return updatedPlayer
        })
        _setTeams({ ...teams, [BATTING_TEAM]: updatedBattingTeam })
        _setPlayers({ [BATTING_TEAM]: updatedBattingPlayerList, [BOWLING_TEAM]: updatedBowlingPlayerList })
        _setOnPitchPlayers(previousOnPitchPlayer)
        // dispatch(undoBallFromCommentary({ "commentaryBallByBallId": currentBall.commentaryBallByBallId }))
        setSaveToDb(true)
        setIsUndoBall(OVER)
    }
    const onUndoPlayerSelection = () => {
        let teamUpdates = undefined
        let commentaryUpdates = undefined

        teamUpdates = [
            { ...teams?.[BATTING_TEAM], isBattingComplete: false, teamStatus: 1 },
            { ...teams?.[BOWLING_TEAM], teamStatus: 2 }]
        commentaryUpdates = {
            "commentaryStatus": 5,
            "target": 0,
            "displayStatus": "Innings"
        }
        let objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryDetails": {
                ...commentaryDetails,
                ...commentaryUpdates
            },
            "commentaryTeams": teamUpdates,
            "commentaryPlayers": [
                { ...onPitchPlayers[ON_STRIKE], isPlay: null, onStrike: null, isPlayInEvent: isPlayerNew(onPitchPlayers[ON_STRIKE]) ? false : onPitchPlayers[ON_STRIKE]?.isPlayInEvent },
                { ...onPitchPlayers[NON_STRIKE], isPlay: null, isPlayInEvent: isPlayerNew(onPitchPlayers[NON_STRIKE]) ? false : onPitchPlayers[NON_STRIKE]?.isPlayInEvent },
                { ...onPitchPlayers[CURRENT_BOWLER], isPlay: null, isPlayInEvent: isPlayerNew(onPitchPlayers[CURRENT_BOWLER]) ? false : onPitchPlayers[CURRENT_BOWLER]?.isPlayInEvent },
            ],
            "updateTeamStatus": extractRequiredFieldsForTeamStatus(teamUpdates),
        }
        setRedirectOnScreenChange(true)
        // console.log("Called from : 17")
        dispatch(addCommentaryScreenData(objToSave))
    }
    const onUndoLastInningsClick = () => {
        let commentaryUpdates = undefined

        let teamUpdates = [
            { ...teams?.[BATTING_TEAM], isBattingComplete: false, teamStatus: 2 },
            { ...teams?.[BOWLING_TEAM], isBattingComplete: false, teamStatus: 1 }]
        commentaryUpdates = {
            "target": 0,
            "displayStatus": "Previous Innings"
        }
        let objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryDetails": { ...commentaryDetails, ...commentaryUpdates },
            "commentaryTeams": teamUpdates,
            "commentaryPlayers": [
                { ...onPitchPlayers[ON_STRIKE], isPlay: null, onStrike: null },
                { ...onPitchPlayers[NON_STRIKE], isPlay: null, },
                { ...onPitchPlayers[CURRENT_BOWLER], isPlay: null, }
            ],
        }
        setRedirectOnScreenChange(true)
        // console.log("Called from : 18")
        dispatch(addCommentaryScreenData(objToSave))
    }
    const onRetiredHurtClick = (retiredHurtData) => {
        // console.log("retiredHurtData", retiredHurtData)
        const updateBall = {
            "commentaryBallByBallId": "0",
            "ballIsCount": false,
            "ballRun": 0,
            "ballExtraRun": 0,
            "batStrikeId": retiredHurtData[PREV_ON_STRIKE]?.commentaryPlayerId,
            "batNonStrikeId": retiredHurtData[PREV_NON_STRIKE]?.commentaryPlayerId,
            "ballType": BALL_TYPE_RETIRED_HURT
        }
        const currentBallDetails = generateBall({ currentBall: updateBall, commentaryDetails, currentOver, onPitchPlayers: retiredHurtData, teams, currentPartnership })
        // const currentBallDetails = { ...currentBall }
        currentBallDetails["nextBatStrikeId"] = retiredHurtData[ON_STRIKE]?.commentaryPlayerId
        currentBallDetails["nextBatNonStrikeId"] = retiredHurtData[NON_STRIKE]?.commentaryPlayerId
        const partnershipDetails = {
            "batter1Id": retiredHurtData[ON_STRIKE]?.commentaryPlayerId,
            "batter1Name": retiredHurtData[ON_STRIKE]?.playerName,
            "batter2Id": retiredHurtData[NON_STRIKE]?.commentaryPlayerId,
            "batter2Name": retiredHurtData[NON_STRIKE]?.playerName,
            "commentaryBallByBallId": (currentBall.commentaryBallByBallId || "0"),
            "batter1Runs": 0,
            "batter2Runs": 0,
            "batter1Balls": 0,
            "batter2Balls": 0,
            "order": teams?.[BATTING_TEAM]?.teamWicket,
            // "order": currentPartnership.order + 1,
            // "order": dd,
            "isActive": true,
        }
        const updatedPartnership = generatePartnership({ commentaryDetails, currentPartnership: partnershipDetails, teams, onPitchPlayers: (isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers) })
        const objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryPartnership": updatedPartnership,
            "commentaryDetails": commentaryDetails,
            "commentaryPlayers": [retiredHurtData[ON_STRIKE], retiredHurtData[NON_STRIKE], retiredHurtData[RETIRED_HURT_BATTER]],
            "commentaryBallByBall": currentBallDetails
        }
        checkForOverSwitch()
        setCurrentPartnership({})
        // console.log("Called from : 19")
        dispatch(addCommentaryScreenData(objToSave))
        setCurrentBall(updateBall)
        setOnPitchPlayers({ ...onPitchPlayers, [ON_STRIKE]: retiredHurtData[ON_STRIKE], [NON_STRIKE]: retiredHurtData[NON_STRIKE] })
        setPlayers({ ...players, [BATTING_TEAM]: retiredHurtData[PLAYER_LIST] })
        setShowRretiredHurt(false)
    }
    const undoRetiredHurt = () => {
        let updatedPlayerList = players[BATTING_TEAM] || []
        const playersToChange = {}
        let updatedOnPitchPlayer = {}
        updatedPlayerList = updatedPlayerList.map(player => {
            let updatedPlayer = player
            if (player.isPlay || player.onStrike) {
                updatedPlayer = { ...updatedPlayer, isPlay: null, onStrike: null }
                if (isPlayerNew(player)) {
                    updatedPlayer["isPlayInEvent"] = false;
                    updatedPlayer["batterOrder"] = null;
                }
                playersToChange[updatedPlayer.commentaryPlayerId] = updatedPlayer
            }

            if (player.commentaryPlayerId === currentBall.batStrikeId) {
                updatedPlayer = { ...updatedPlayer, isPlay: true, onStrike: true, isPlayInEvent: true, isBatterRetir: null }
                updatedOnPitchPlayer[ON_STRIKE] = updatedPlayer
                playersToChange[updatedPlayer.commentaryPlayerId] = updatedPlayer
            } else if (player.commentaryPlayerId === currentBall.batNonStrikeId) {
                updatedPlayer = { ...updatedPlayer, isPlay: true, onStrike: null, isPlayInEvent: true, isBatterRetir: null }
                updatedOnPitchPlayer[NON_STRIKE] = updatedPlayer
                playersToChange[updatedPlayer.commentaryPlayerId] = updatedPlayer
            }
            return updatedPlayer
        })
        const objToSave = {
            "commentaryId": commentaryDetails.commentaryId,
            "isCallPredict": props?.isPredictToggle,
            "commentaryPlayers": Object.values(playersToChange),
            "deleteCommentaryBallByBallId": currentBall.commentaryBallByBallId
        }
        // console.log("Called from : 20")
        dispatch(addCommentaryScreenData(objToSave))
        setPlayers({ ...players, [BATTING_TEAM]: updatedPlayerList })
        setOnPitchPlayers({ ...onPitchPlayers, ...updatedOnPitchPlayer })
        setIsUndoBall(RETIRED_HURT)
    }
    const initialDataLoad = () => {
        const currentInningsTeams = {}
        const battingTeam = []
        const bowlingTeam = []
        const onPitchPlayers = {}
        let partnershipFromApi = {}
        const apiCallObj = {}
        let currentOver = 0
        let currentOverToUpdate = 0
        let targetToUpdate = 0
        propsData.commentaryData.commentaryTeams.forEach(teamDetails => {
            if (isEqual(teamDetails.currentInnings, commentaryDetails.currentInnings)) {
                const isBattingTeam = teamDetails.teamStatus === BAT
                currentInningsTeams[isBattingTeam ? BATTING_TEAM : BOWLING_TEAM] = teamDetails
                if (isBattingTeam) {
                    currentOver = Math.floor(teamDetails?.teamOver)
                    const trail = (+teamDetails?.teamTrialRuns || 0)
                    if (trail > -1) targetToUpdate = trail + 1
                }
            }
        });
        if (currentInningsTeams?.[BOWLING_TEAM]?.isBattingComplete) setTarget(targetToUpdate)
        propsData.commentaryData.commentaryPlayers.forEach(playerDetails => {
            // if (isEqual(playerDetails.currentInnings, commentaryDetails.currentInnings)) {
            const isBattingTeam = playerDetails?.teamId === currentInningsTeams[BATTING_TEAM]?.teamId
            // If player is from batting team, add them to the batting object list
            if (isBattingTeam) {
                if (playerDetails.isPlay === true) {
                    if (!playerDetails.batterOrder) {
                        playerDetails = { ...playerDetails, batterOrder: playerDetails.onStrike === true ? 1 : 2 }
                        apiCallObj["commentaryPlayers"] = [].concat((apiCallObj.commentaryPlayers || []), [playerDetails])
                    }
                    onPitchPlayers[playerDetails.onStrike === true ? ON_STRIKE : NON_STRIKE] = playerDetails
                }
                battingTeam.push(playerDetails)
            }
            else {
                if (playerDetails.isPlay === true) {
                    if (!playerDetails.bowlerOrder) {
                        playerDetails = { ...playerDetails, bowlerOrder: 1 }
                        apiCallObj["commentaryPlayers"] = [].concat((apiCallObj.commentaryPlayers || []), [playerDetails])
                    }
                    onPitchPlayers[CURRENT_BOWLER] = playerDetails
                }
                bowlingTeam.push(playerDetails)
            }
            // }
        });
        // propsData.commentaryData.commentaryPartnership.forEach(partnershipDetails => {
        //     if (
        //         (isEqual(partnershipDetails.batter1Id, onPitchPlayers[ON_STRIKE]?.commentaryPlayerId) &&
        //             isEqual(partnershipDetails.batter2Id, onPitchPlayers[NON_STRIKE]?.commentaryPlayerId)) ||
        //         (
        //             isEqual(partnershipDetails.batter1Id, onPitchPlayers[NON_STRIKE]?.commentaryPlayerId) &&
        //             isEqual(partnershipDetails.batter2Id, onPitchPlayers[ON_STRIKE]?.commentaryPlayerId)
        //         )) {
        //         partnershipFromApi = partnershipDetails
        //     }
        // });
        partnershipFromApi = propsData.commentaryData.commentaryPartnership?.find((i) => i?.isActive && i?.currentInnings == commentaryDetails?.currentInnings && i?.teamId == currentInningsTeams?.[BATTING_TEAM]?.teamId) || {};
        propsData.commentaryData.commentaryOvers.forEach(overDetails => {
            if (
                isEqual(+overDetails.teamId, currentInningsTeams?.[BATTING_TEAM]?.teamId) &&
                isEqual(+overDetails.over, +currentOver) &&
                isEqual(+overDetails?.currentInnings, commentaryDetails.currentInnings)) currentOverToUpdate = overDetails
        });
        const ballData = propsData.commentaryData.commentaryBallByBall || []
        let ballByBallHistoryData = ballData?.commentaryBallByBallId ? [ballData] : ballData
        ballByBallHistoryData = _.orderBy(ballByBallHistoryData, ["commentaryBallByBallId"], ["asc"])
        const overData = propsData.commentaryData.commentaryOvers || []
        let overHistoryData = overData.overId ? [overData] : overData
        overHistoryData = _.orderBy(overHistoryData, ["overId"], ["asc"])
        const partnershipData = propsData.commentaryData.commentaryPartnership || []
        let currentBallToUpdate = currentBall.commentaryBallByBallId ? currentBall : _.isArray(ballByBallHistoryData) ? ballByBallHistoryData[ballByBallHistoryData.length - 1] : undefined
        let partnershipHistoryData = partnershipData.commentaryPartnershipId ? [partnershipData] : (!isEmpty(partnershipData) && !isEmpty(partnershipFromApi))
            ? [
                ...partnershipData.filter(
                    obj => obj.batter1Id !== partnershipFromApi.batter1Id ||
                        obj.batter2Id !== partnershipFromApi.batter2Id
                ),
                { ...partnershipFromApi, "commentaryBallByBallId": currentBallToUpdate?.commentaryBallByBallId }
            ]
            : partnershipData;
        // let partnershipHistoryData = partnershipData.commentaryPartnershipId ? [partnershipData] : !isEmpty(partnershipData) ?
        //     [{ ...partnershipFromApi, "commentaryBallByBallId": currentBallToUpdate }] : partnershipData
        partnershipHistoryData = _.orderBy(partnershipHistoryData, ["commentaryPartnershipId"], ["asc"])
        // console.log("initialLoad onPitchPlayers", onPitchPlayers)
        const partnershipDetails = {
            "batter1Id": onPitchPlayers[ON_STRIKE]?.commentaryPlayerId,
            "batter1Name": onPitchPlayers[ON_STRIKE]?.playerName,
            "batter2Id": onPitchPlayers[NON_STRIKE]?.commentaryPlayerId,
            "batter2Name": onPitchPlayers[NON_STRIKE]?.playerName,
            "commentaryBallByBallId": currentBallToUpdate?.commentaryBallByBallId || "0",
            "order": currentInningsTeams?.[BATTING_TEAM]?.teamWicket || 1,
            // "order": currentPartnership.order + 1 || 1,
            "isActive": true,
        }
        let selectedOverType = null
        const overTypeOptionsData = propsData.commentaryData?.overTypes?.map((element) => {
            if (element.isActive) {
                const valueSet = {
                    label: element.overType,
                    value: element.id
                }
                if (element.isDefault) selectedOverType = valueSet
                return valueSet
            }
            else return null
        }).filter(x => x)
        setTeams(currentInningsTeams)
        setAllIningsTeams(propsData.commentaryData.commentaryTeams)
        setPlayers({ [BATTING_TEAM]: battingTeam, [BOWLING_TEAM]: bowlingTeam })
        setOnPitchPlayers(onPitchPlayers)
        setOverBallByBallDisplay(getBallsForAllOver(ballByBallHistoryData, propsData.commentaryData.commentaryWicket))
        setBallHistory(ballByBallHistoryData)
        setOverTypeOptions(overTypeOptionsData)
        // try {
        //     axiosInstance.post(`/admin/score/commentaryConsoleFe`, {
        //         ballCount: teams[BATTING_TEAM]?.teamOver, ballHistoryData: { type: "BallByBallLog", history: ballByBallHistoryData }
        //     });
        //     console.log("BallbyBall history ->>>>>>>>", { hstory: ballByBallHistoryData })
        // } catch (error) {
        //     console.error("Error updating commentary console:", error);
        // }
        setOverHistory(overHistoryData)
        setPartnershipHistory(partnershipHistoryData)
        setWicketHistory(propsData.commentaryData.commentaryWicket)
        setCurrentPartnership(partnershipFromApi)
        setCurrentOver(currentOverToUpdate)
        setSelectedOverType({
            label: currentOverToUpdate?.overTypeName,
            value: currentOverToUpdate?.overType
        })
        setCurrentBall(currentBallToUpdate)
        if (!isEmpty(currentBallToUpdate)) setBallCountForStrike((currentBallToUpdate.autoStrikeBallCount || 0) + 1)
        setIsLastInnings(commentaryDetails.currentInnings >= matchTypeDetails.noOfIningsPerSide)
        // console.log("Partnership Found in API", { partnershipFromApi, onPitchPlayers })
        if (isEmpty(partnershipFromApi) && onPitchPlayers[ON_STRIKE]?.commentaryPlayerId
            && onPitchPlayers[NON_STRIKE]?.commentaryPlayerId)
            apiCallObj["commentaryPartnership"] = generatePartnership({ commentaryDetails, currentPartnership: partnershipDetails, teams: currentInningsTeams, onPitchPlayers: (isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers) })
        // console.log("GENERATING PARTNERSHIP", apiCallObj.commentaryPartnership)
        if (!currentOverToUpdate && onPitchPlayers[CURRENT_BOWLER]?.commentaryPlayerId) {
            apiCallObj["commentaryOvers"] = generateOver({
                commentaryDetails, onPitchPlayers, teams: currentInningsTeams, selectedOverType
            })
        }
        if (!isEmpty(apiCallObj)) {
            // console.log("Called from : 21 ");
            dispatch(addCommentaryScreenData({
                ...apiCallObj,
                "commentaryId": commentaryDetails.commentaryId,
                "isCallPredict": props?.isPredictToggle,
            }))
        }
    }
    const updateTempToMain = () => {
        // console.log("_currentPartnership", _currentPartnership)
        if (!isEmpty(_currentOver)) {
            setCurrentOver(_currentOver)
            _setCurrentOver()
        }
        if (!isEmpty(_currentPartnership)) {
            setCurrentPartnership(_currentPartnership)
            _setCurrentPartnership()
        }
        if (!isEmpty(_onPitchPlayers)) {
            setOnPitchPlayers(_onPitchPlayers)
            _setOnPitchPlayers()
        }
        if (!isEmpty(_players)) {
            setPlayers(_players)
            _setPlayers()
        }
        if (!isEmpty(_teams)) {
            setTeams(_teams)
            _setTeams()
        }
        // console.log("update to main currentPartnership", currentPartnership)
    }
    useEffect(() => {
        if (superOverApiData) {
            props.onInningsChange()
            dispatch(clearAddCommentaryScreenData())
        }
    }, [superOverApiData])
    useEffect(() => {
        if (updateRunsFromWicket) {
            updateRuns(updateRunsFromWicket)
        }
    }, [updateRunsFromWicket])

    useEffect(() => {
        if (!isEmpty(commentaryDetails) && ballStatus) {
            if (socket) {
                const playersList = _players?.[BATTING_TEAM] || players?.[BATTING_TEAM] || [];

                const filteredPlayersList = playersList?.length > 0 && playersList.map(player => ({
                    playerId: player?.playerId,
                    commentaryPlayerId: player?.commentaryPlayerId,
                    playerName: player?.playerName,
                    batBall: player?.batBall,
                    batRun: player?.batRun,
                    batsmanAverage: player?.batsmanAverage,
                }));

                const partnershipData = isEmpty(_currentPartnership) ? currentPartnership : _currentPartnership;

                const currPartnership = {
                    commentaryBallByBallId: partnershipData?.commentaryBallByBallId,
                    commentaryId: partnershipData?.commentaryId,
                    commentaryPartnershipId: partnershipData?.commentaryPartnershipId,
                    currentInnings: partnershipData?.currentInnings,
                    isActive: partnershipData?.isActive,
                    order: partnershipData?.order,
                    teamId: partnershipData?.teamId,
                    totalBalls: partnershipData?.totalBalls,
                    totalExtra: partnershipData?.totalExtra,
                    totalFour: partnershipData?.totalFour,
                    totalNoBall: partnershipData?.totalNoBall,
                    totalRuns: partnershipData?.totalRuns,
                    totalSix: partnershipData?.totalSix,
                    totalWide: partnershipData?.totalWide,

                }

                socket.emit(COMMENTARY_UPDATE, { ballStatus: ballStatus, eventRefId: commentaryDetails?.eventRefId, commentaryId: commentaryDetails?.commentaryId, teamId: _teams?.[BATTING_TEAM]?.teamId || teams?.[BATTING_TEAM]?.teamId, wicket: _teams?.[BATTING_TEAM]?.teamWicket || teams?.[BATTING_TEAM]?.teamWicket, score: _teams?.[BATTING_TEAM]?.teamScore || teams?.[BATTING_TEAM]?.teamScore, over: _teams?.[BATTING_TEAM]?.teamOver || teams?.[BATTING_TEAM]?.teamOver, oversPerInings: matchTypeDetails?.oversPerInings, playersList: filteredPlayersList, currentPartnership: currPartnership });
            }
        }
    }, [commentaryDetails, ballStatus, matchTypeDetails?.oversPerInings, currentOver?.ballCount]);

    useEffect(() => {
        if (isUndoCompleted) {
            if (isUndoBall === WICKET || isUndoBall === RETIRED_HURT) {
                const updatedWicketHistory = wicketHistory.slice(0, -1)
                const updaterPartnershipHistory = partnershipHistory.slice(0, -1)
                setWicketHistory(updatedWicketHistory)
                setPartnershipHistory(updaterPartnershipHistory)
                setCurrentPartnership(updaterPartnershipHistory[updaterPartnershipHistory.length - 1])
            }
            else if (isUndoBall === OVER) {
                const updatedOverHistory = overHistory.slice(0, -1)
                const newCurrentOver = { ...updatedOverHistory[updatedOverHistory.length - 1] }
                newCurrentOver["teamScore"] = { ...currentOver, "teamScore": `${teams[BATTING_TEAM]?.teamScore || 0}/${teams[BATTING_TEAM]?.teamWicket || 0}`, "isComplete": true }
                newCurrentOver["isComplete"] = false
                setOverHistory(updatedOverHistory)
                setCurrentOver(newCurrentOver)
            }
            // else {
            //     updatedBallHistory = overBallByBallDisplay.slice(0, -1)
            // }
            const updatedBallHistoryList = ballHistory.slice(0, -1)
            // setOverBallByBallDisplay(updatedBallHistory)
            setBallHistory(updatedBallHistoryList)
            // try {
            //     axiosInstance.post(`/admin/score/commentaryConsoleFe`, { ballCount: teams[BATTING_TEAM]?.teamOver, ballHistoryData: { type: "BallByBallLog", history: updatedBallHistoryList } });
            //     console.log("BallbyBall history ->>>>>>>>", { history: updatedBallHistoryList })
            // } catch (error) {
            //     console.error("Error updating commentary console:", error);
            // }
            setCurrentBall(updatedBallHistoryList[updatedBallHistoryList.length - 1])
            setIsUndoBall(undefined)
            dispatch(clearUndoFlag())
        }
    }, [isUndoCompleted])
    useEffect(() => {
        if (redirectOnScreenChange && isCommentaryDataUpdated) {
            props.onInningsChange()
            dispatch(clearAddCommentaryScreenData())
        }
    }, [redirectOnScreenChange, isCommentaryDataUpdated])
    useEffect(() => {
        if (changeOverOnPopupClick) {
            const syncOnPitchPlayers = isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers;
            // setOverBallByBallDisplay([])
            // if(!inningsChangeClosed) {
            checkInningsSwitch(OVER)
            // }
            changePlayer(CURRENT_BOWLER)
            setOnPitchPlayers({ ...syncOnPitchPlayers, [CURRENT_BOWLER]: null })
            changeOver()
            setOverPopUpForBowler(true)
            setChangeOverOnPopupClick(undefined)
            // setInningsChangeClosed(false);
        }
    }, [changeOverOnPopupClick])
    useEffect(() => {
        if (saveToDb) {
            if (updateRunsFromWicket) callWicketToDB()
            else {
                let newCurrentBall = undefined
                let objToSave = {}
                if (isUndoBall) {
                    newCurrentBall = currentBall
                    objToSave["deleteCommentaryBallByBallId"] = currentBall.commentaryBallByBallId
                    if (isUndoBall === OVER) objToSave["deleteOverId"] = currentOver.overId
                }
                else newCurrentBall = { ...currentBall, commentaryBallByBallId: "0" }
                const generatedBallByBall = generateBall({
                    currentBall: newCurrentBall, commentaryDetails,
                    currentOver: _currentOver || currentOver, onPitchPlayers: _onPitchPlayers || onPitchPlayers, teams: _teams || teams,
                    currentPartnership
                })
                const generatePartnershipData = generatePartnership({
                    commentaryDetails, currentBall: {},
                    currentPartnership: isEmpty(_currentPartnership) ? currentPartnership : _currentPartnership, teams: _teams, onPitchPlayers: (isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers)
                })
                objToSave = {
                    ...objToSave,
                    "commentaryId": commentaryDetails.commentaryId,
                    "isCallPredict": props?.isPredictToggle,
                    "commentaryBallByBall": generatedBallByBall,
                    "commentaryOvers": {
                        ..._currentOver,
                        "teamScore": `${_teams[BATTING_TEAM]?.teamScore || 0}/${_teams[BATTING_TEAM]?.teamWicket || 0}`
                    },
                    "commentaryPlayers": [].concat(playerUpdateList, Object.values(_onPitchPlayers)).filter(x => x),
                    "commentaryPartnership": generatePartnershipData,
                    "commentaryDetails": {
                        ...commentaryDetails,
                        "displayStatus": generateDisplayStatus({ currentBall: generatedBallByBall }),
                        "rmk": isRemainingBallsShow ? generateRemainingRuns(_teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : ""
                    },
                    "commentaryTeams": [_teams[BATTING_TEAM]],
                }
                if (objToSave.deleteCommentaryBallByBallId) delete objToSave.commentaryBallByBall
                if (objToSave.deleteOverId) delete objToSave.commentaryOvers
                // console.log("Called from : 22");
                // const partnershipDetailsForConsole = {
                //     "batsmen1": objToSave.commentaryPartnership.batter1Name,
                //     "batsmen2": objToSave.commentaryPartnership.batter2Name,
                //     "partnership_no": objToSave.commentaryPartnership.order
                // }
                // console.log("partnership details", partnershipDetailsForConsole);
                // console.log("useEffect normal balls", objToSave)
                if (!objToSave?.commentaryPartnership?.batter1Id && !objToSave?.commentaryPartnership?.batter2Id) {
                    // handleCommentaryConsole(_currentOver, currentOver, objToSave, currentPartnership);
                    dispatch(
                        updateToastData({
                            title: 'Partnership issue',
                            data: 'batter1 or batter2 is null',
                            type: ERROR,
                        })
                    );
                }
                // dispatch(addCommentaryScreenData(objToSave))
                // setSaveToDb(false)

                // const timeoutId = setTimeout(() => {
                //     dispatch(addCommentaryScreenData(objToSave));
                //     setSaveToDb(false);
                // }, 300); // 300ms delay before calling dispatch
                // return () => clearTimeout(timeoutId);

                // throttledDispatchAdd(objToSave);
                //     setSaveToDb(false);
                setIsSaving(true);
                Promise.resolve(dispatch(addCommentaryScreenData(objToSave)))
                    .finally(() => {
                        setIsSaving(false);
                        setSaveToDb(false);
                    });
            }
        }
    }, [saveToDb]);
    useEffect(() => {
        if (isOverChange) {
            const objToSave = {
                "commentaryId": commentaryDetails.commentaryId,
                "isCallPredict": props?.isPredictToggle,
                "commentaryDetails": { ...commentaryDetails, "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : "" },
                "commentaryOvers": generateOver({ commentaryDetails, onPitchPlayers, teams, selectedOverType }),
                "commentaryPlayers": [].concat(Object.values(onPitchPlayers), playerUpdateList).filter(x => x),
                "commentaryTeams": [teams[BATTING_TEAM]],
            }
            // console.log("Called from : 23");
            // dispatch(addCommentaryScreenData(objToSave))
            setIsSaving(true);
            Promise.resolve(dispatch(addCommentaryScreenData(objToSave)))
                .finally(() => {
                    setIsSaving(false);
                });
            setIsOverChange(undefined)
            setPlayerUpdateList([])
        }
    }, [isOverChange])
    useEffect(() => {
        if (isEmpty(propsData) && !isEmpty(props.data)) {
            const remainingBallsShow = props?.data?.commentaryData?.commentaryTeams.some(team => team.isBattingComplete)
            setPropsData(props.data)
            setIsWheelShow(props?.data?.commentaryData?.commentaryDetails?.isWheelShow);
            setIsRemainingBallsShow(remainingBallsShow);
            setIsShotType(props?.data?.commentaryData?.commentaryDetails?.shotType);
            setCommentaryDetails({ ...props.data.commentaryData.commentaryDetails, "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : "", displayStatus: "" })
            setMatchTypeDetails(props.data.commentaryData.matchTypeDetails)
        }
        props.saveUserInfo()
    }, [])
    useEffect(() => {
        if (!isEmpty(propsData)) {
            setCheckIfUndoFromMaster(true);
            initialDataLoad();
        }
    }, [propsData])
    useEffect(() => {
        if (props.IsCommentaryWithUndo) {
            if (checkIfUndoFromMaster) {
                setShowChangeOverModal(false);
                handleUndoClick();
                props.toggleCommenatryWithUndo();
                setCheckIfUndoFromMaster(false);
            }
        }
    }, [checkIfUndoFromMaster]);
    useEffect(() => {
        if (!isEmpty(commentaryDataToUpdate)) {
            // Update Over history on over change
            setIsWheelShowComplete(false);
            if (isWheelShow) {
                if (commentaryDataToUpdate?.commentaryBallByBallDetails?.ballRun && !showWicketModal) {
                    setShowCricketFieldModal(true);
                    setCricketFieldData({ commentaryId: commentaryDetails.commentaryId, commentaryBallByBallId: commentaryDataToUpdate?.commentaryBallByBallDetails?.commentaryBallByBallId, run: commentaryDataToUpdate?.commentaryBallByBallDetails?.ballRun, isBoundary: commentaryDataToUpdate?.commentaryBallByBallDetails?.ballIsBoundry, batter: onPitchPlayers[ON_STRIKE]?.playerName, bowler: onPitchPlayers[CURRENT_BOWLER]?.playerName, overCount: commentaryDataToUpdate?.commentaryBallByBallDetails?.overCount });
                } else if (commentaryDataToUpdate?.commentaryBallByBallDetails?.ballRun === 0) {
                    setIsWheelShowComplete(true);
                }
            }
            if (!isEmpty(commentaryDataToUpdate.commentaryTeams)) {
                const updatedTeamsState = { ...teams };

                commentaryDataToUpdate.commentaryTeams.forEach(teamUpdate => {
                    if (teams[BATTING_TEAM] && compareNumStringValues(teamUpdate.teamId, teams[BATTING_TEAM].teamId)) {
                        const apiTeamOver = parseFloat(teamUpdate.teamOver || 0);
                        const currentTeamOver = parseFloat(teams[BATTING_TEAM].teamOver || 0);

                        if (apiTeamOver >= currentTeamOver) {
                            updatedTeamsState[BATTING_TEAM] = { ...teams[BATTING_TEAM], ...teamUpdate };
                        }
                        else {
                            updatedTeamsState[BATTING_TEAM] = {
                                ...teams[BATTING_TEAM],
                                ...teamUpdate,
                                teamOver: teams[BATTING_TEAM].teamOver
                            };
                        }
                    } else if (teams[BOWLING_TEAM] && compareNumStringValues(teamUpdate.teamId, teams[BOWLING_TEAM].teamId)) {
                        updatedTeamsState[BOWLING_TEAM] = { ...teams[BOWLING_TEAM], ...teamUpdate };
                    }
                });

                setTeams(updatedTeamsState);
            }
            if (!isEmpty(commentaryDataToUpdate.overdetails) && !isEqual(commentaryDataToUpdate.overdetails.overId, currentOver.overId)) {
                _setCurrentOver({})
                const updatedOverHistory = overHistory.slice(0, -1)
                setOverHistory([].concat(updatedOverHistory || [], [currentOver, commentaryDataToUpdate.overdetails]))
                const generatedBall = generateBall({ currentBall: { commentaryBallByBallId: "0", }, commentaryDetails, currentOver: { overId: commentaryDataToUpdate.overdetails.overId }, onPitchPlayers, teams, currentPartnership })
                // console.log("Called from : 24");
                // dispatch(addCommentaryScreenData({
                //     "commentaryId": commentaryDetails.commentaryId,
                //     "isCallPredict": props?.isPredictToggle,
                //     "commentaryDetails": { ...commentaryDetails, "displayStatus": generateDisplayStatus({ currentBall: generatedBall }), "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails): "" },
                //     "commentaryBallByBall": generatedBall,
                // }))
                setIsSaving(true);
                Promise.resolve(dispatch(addCommentaryScreenData({
                    "commentaryId": commentaryDetails.commentaryId,
                    "isCallPredict": props?.isPredictToggle,
                    "commentaryDetails": { ...commentaryDetails, "displayStatus": generateDisplayStatus({ currentBall: generatedBall }), "rmk": isRemainingBallsShow ? generateRemainingRuns(teams[BATTING_TEAM], matchTypeDetails.ballsPerOver, matchTypeDetails) : "" },
                    "commentaryBallByBall": generatedBall,
                })))
                    .finally(() => {
                        setIsSaving(false);
                    });
                setCurrentOver(commentaryDataToUpdate.overdetails)
            }
            const commentartBallByBallIdToUpdate = commentaryDataToUpdate?.commentaryBallByBallDetails?.commentaryBallByBallId
            // Update ball history on ball change
            if (!isEmpty(commentaryDataToUpdate.commentaryBallByBallDetails)
                && !compareNumStringValues(currentBall?.commentaryBallByBallId, commentaryDataToUpdate.commentaryBallByBallDetails.commentaryBallByBallId)) {
                // If Partnership Ball By ball Id is not correct, then update it
                if ((!currentPartnership?.commentaryBallByBallId || +currentPartnership?.commentaryBallByBallId === 0)) {
                    // console.log("2095 currentPartnership before", currentPartnership)
                    setCurrentPartnership({ ...currentPartnership, "commentaryBallByBallId": commentartBallByBallIdToUpdate })
                    // console.log("2097 currentPartnership after", currentPartnership)
                }
                setBallHistory([].concat(ballHistory || [], [commentaryDataToUpdate.commentaryBallByBallDetails]))
                // try {
                //     axiosInstance.post(`/admin/score/commentaryConsoleFe`, { ballCount: teams[BATTING_TEAM]?.teamOver, ballHistoryData: { type: "BallByBallLog", history: [].concat(ballHistory || [], [commentaryDataToUpdate.commentaryBallByBallDetails]) } });
                //     console.log("BallbyBall history ->>>>>>>>", { hstory: [].concat(ballHistory || [], [commentaryDataToUpdate.commentaryBallByBallDetails]) })
                // } catch (error) {
                //     console.error("Error updating commentary console:", error);
                // }
                setCurrentBall(commentaryDataToUpdate.commentaryBallByBallDetails);
                //checkForOverSwitch(_currentOver?.ballCount || currentOver?.ballCount)
                // handleCommentaryConsole(_currentOver, currentOver);
                // console.log(`Temporary _over : ${_currentOver?.over}, _ballCount: ${_currentOver?.ballCount}, _teamScore: ${_currentOver?.teamScore} & permanent over : ${currentOver?.over}, ballCount: ${currentOver?.ballCount}, teamScore: ${currentOver?.teamScore}`);
            } else if (
                currentBall.commentaryBallByBallId && commentaryDataToUpdate.commentaryBallByBallDetails
                && isEqual(currentBall.commentaryBallByBallId, commentaryDataToUpdate.commentaryBallByBallDetails?.commentaryBallByBallId)
                && !isEqual(currentBall, commentaryDataToUpdate.commentaryBallByBallDetails)) {
                setBallHistory([].concat((ballHistory.slice(0, -1) || []), [commentaryDataToUpdate.commentaryBallByBallDetails]))
                // try {
                //     axiosInstance.post(`/admin/score/commentaryConsoleFe`, {
                //         ballCount: teams[BATTING_TEAM]?.teamOver, ballHistoryData: { type: "BallByBallLog", history: [].concat((ballHistory.slice(0, -1) || []), [commentaryDataToUpdate.commentaryBallByBallDetails]) }
                //     });
                //     console.log("BallbyBall history ->>>>>>>>", { hstory: [].concat((ballHistory.slice(0, -1) || []), [commentaryDataToUpdate.commentaryBallByBallDetails]) })
                // } catch (error) {
                //     console.error("Error updating commentary console:", error);
                // }
            }
            const partnershipFromApi = commentaryDataToUpdate?.commentaryPartnershipDetails
            //   console.log("commentaryDataToUpdate?.commentaryPartnershipDetails", commentaryDataToUpdate?.commentaryPartnershipDetails)
            //   console.log("currentPartnership?.commentaryPartnershipId", currentPartnership?.commentaryPartnershipId)
            //   console.log("+currentPartnership?.commentaryPartnershipId == 0", +currentPartnership?.commentaryPartnershipId)
            //   console.log("isEmpty(currentPartnership)", isEmpty(currentPartnership))
            // console.log("partnershipFromApi", partnershipFromApi)
            //   console.log("!isEmpty(partnershipFromApi)", isEmpty(partnershipFromApi))
            //   console.log("(!currentPartnership?.commentaryPartnershipId && (+currentPartnership?.commentaryPartnershipId == 0))", (!currentPartnership?.commentaryPartnershipId && (+currentPartnership?.commentaryPartnershipId == 0)))
            // console.log("full condition", (isEmpty(currentPartnership) || (!currentPartnership?.commentaryPartnershipId && (+currentPartnership?.commentaryPartnershipId == 0))) && (!isEmpty(partnershipFromApi) || (partnershipFromApi?.commentaryPartnershipId && (+partnershipFromApi?.commentaryPartnershipId != 0))))
            if (
                (isEmpty(currentPartnership) || (!currentPartnership?.commentaryPartnershipId && (+currentPartnership?.commentaryPartnershipId == 0)))
                &&
                (!isEmpty(partnershipFromApi) || (partnershipFromApi?.commentaryPartnershipId && (+partnershipFromApi?.commentaryPartnershipId != 0)))) {
                const newPartnership = {
                    ...commentaryDataToUpdate.commentaryPartnershipDetails,
                    "commentaryBallByBallId": (commentartBallByBallIdToUpdate || currentBall.commentaryBallByBallId),
                    isActive: true,
                }
                // console.log("if 3")
                // console.log("2120 new before", newPartnership)
                setCurrentPartnership(newPartnership)
                //   console.log("2122 currentPartnership after", currentPartnership)
                setPartnershipHistory([].concat(partnershipHistory || [], [newPartnership]))
            }
            // Update Current Wicket on Wicket change
            if (!isEmpty(commentaryDataToUpdate.commentaryWicketDetails) && !currentWicket?.commentaryWicketId) {
                setWicketHistory([].concat(wicketHistory || [], [commentaryDataToUpdate.commentaryWicketDetails]))
                setCurrentWicket(commentaryDataToUpdate.commentaryWicketDetails)
            }
            if (!isEmpty(commentaryDataToUpdate?.commentaryDetails)) {
                props?.setIsPredict(commentaryDataToUpdate.commentaryDetails?.isPredictMarket);
                if (!commentaryDataToUpdate.commentaryDetails?.isPredictMarket) {
                    props?.setIsPredictToggle(commentaryDataToUpdate.commentaryDetails?.isPredictMarket)
                }
            }
            // }
            updateTempToMain()
            setPlayerUpdateList(undefined)
            checkInningsSwitch(RUN)
            dispatch(clearAddCommentaryScreenData())
        }
    }, [commentaryDataToUpdate])
    useEffect(() => {
        if (!inningsChangePopup && !redirectOnScreenChange && !onPitchPlayers[ON_STRIKE]?.playerId || !onPitchPlayers[NON_STRIKE]?.playerId || !onPitchPlayers[CURRENT_BOWLER]?.playerId) {
            setSelectMissingPlayer(true)
        } else if (onPitchPlayers[ON_STRIKE]?.playerId && onPitchPlayers[NON_STRIKE]?.playerId && onPitchPlayers[CURRENT_BOWLER]?.playerId) setSelectMissingPlayer(false)
    }, [onPitchPlayers, inningsChangePopup, redirectOnScreenChange])
    useEffect(() => {
        if (matchTypeDetails?.isAutoChangeStriker
            && !changePlayerList
            && (ballCountForStrike > matchTypeDetails?.autoChangeStrikerAfterBall)
            && !isMatchCompleted
            && !isCommentaryBallLoading) {
            changeStrike()
            setBallCountForStrike(1)
        }
    }, [ballCountForStrike, changePlayerList, isCommentaryBallLoading])
    useEffect(() => {
        if (currentOver.overId) {
            let getCurrentOverToBallStatus = getBallsForAllOver(ballHistory, wicketHistory)
            const overToCheckFor = currentOver.currentInnings + STRING_SEPERATOR + teams[BATTING_TEAM]?.teamId + STRING_SEPERATOR + (+currentOver.over + 1)
            if (!getCurrentOverToBallStatus[overToCheckFor]) getCurrentOverToBallStatus = { [overToCheckFor]: [], ...getCurrentOverToBallStatus }
            setOverBallByBallDisplay(getCurrentOverToBallStatus)
        }
    }, [currentOver, ballHistory])
    useEffect(() => { if (error) setRetryModel(error) }, [error])

    const handleWheelShowToggle = async (value) => {
        await axiosInstance
            .post(`/admin/commentary/upIsWheelShow`, {
                commentaryId: commentaryDetails.commentaryId,
                isWheelShow: value,
            })
            .then((response) => {
                setIsWheelShow(value);
                dispatch(
                    updateToastData({
                        data: response?.message,
                        title: response?.title,
                        type: SUCCESS,
                    })
                );
            })
            .catch((error) => {
                dispatch(
                    updateToastData({
                        data: error?.message,
                        title: error?.title,
                        type: ERROR,
                    })
                );
            });
    };
    const handleRemainingBallsShowToggle = (value) => {
        setIsRemainingBallsShow(value ? value : !isRemainingBallsShow)
    }
    const handleOverTypeChange = async (overTypeValue, overTypeName) => {
        await axiosInstance
            .post(`/admin/commentary/overTypeChange`, {
                commentaryId: commentaryDetails.commentaryId,
                overId: currentOver.overId,
                overType: overTypeValue,
                overTypeName: overTypeName
            })
            .then((response) => {
                setSelectedOverType({
                    label: overTypeName,
                    value: overTypeValue
                })
                setCurrentOver((prev) => {
                    return {
                        ...prev,
                        overType: overTypeValue,
                        overTypeName: overTypeName
                    }
                })
                dispatch(
                    updateToastData({
                        data: response?.message,
                        title: response?.title,
                        type: SUCCESS,
                    })
                );
            })
            .catch((error) => {
                dispatch(
                    updateToastData({
                        data: error?.message,
                        title: error?.title,
                        type: ERROR,
                    })
                );
            });
    }
    const handleDefaultOverSwitch = () => {
        setIsDefaultOverType(!isDetaultOverType)
    }
    const handleShotTypeToggle = async (value) => {
        await axiosInstance
            .post(`/admin/commentary/upShotType`, {
                commentaryId: cricketFieldData?.commentaryId,
                shotType: value,
            })
            .then((response) => {
                setIsShotType(value);
                dispatch(
                    updateToastData({
                        data: response?.message,
                        title: response?.title,
                        type: SUCCESS,
                    })
                );
            })
            .catch((error) => {
                dispatch(
                    updateToastData({
                        data: error?.message,
                        title: error?.title,
                        type: ERROR,
                    })
                );
            });
    };

    const isAnyPopupOpen = showChangeOverModal || showWicketModal || isOverChange || isPaneltyPopup || undoOverPopup || isWicketChange || inningsChangePopup || showUpdateInnings || winnerAnnouncement || isUndoBall || undoErrorModal || undoInningsPopup || completeMatchModal || selectMissingPlayer || showRretiredHurt || superOverModal || retryModel || showCricketFieldModal;

    const hasBattingComplete = allInningaTeams.some(t => t.isBattingComplete);
    const showInningsButton = hasBattingComplete && (currentBall?.ballType === BALL_TYPE_OVER_COMPLETE) && (currentBall?.overCount == 0);
    return <>
        {props?.isNewUi ?
            <NewCommentaryScreen
                refId={props.refId}
                currentInnings={teams && teams[BATTING_TEAM]?.teamTrialRuns}
                commentaryId={commentaryDetails?.commentaryId}
                teamDetails={teams}
                onPitchPlayers={onPitchPlayers}
                updateRuns={updateRuns}
                changePlayer={(type) => {
                    setIsSwapPlayer(true)
                    changePlayer(type)
                }}
                changeOver={() => { setShowChangeOverModal(true); }}
                updateExtras={(extraType) => {
                    setExtrasType(extraType)
                }}
                onWicketClick={() => { setShowWicketModal(true) }}
                changeStrike={changeOnStrikePlayer}
                endInnings={() => setShowInningsChangePopup(true)}
                onUndoClick={handleUndoClick}
                isLoading={isCommentaryBallLoading}
                changeBowler={() => {
                    setIsChangeBowler({ isChange: null, isChangePopup: true, popupOption: null })
                }}
                updateDisplayStatus={(displayStatus) => {
                    setBallStatus(BALL_START_STATUS);
                    dispatch(updateCommentaryBallStatus({
                        "commentaryId": commentaryDetails.commentaryId,
                        "displayStatus": displayStatus,
                        "commentaryPlayerId": onPitchPlayers[ON_STRIKE].commentaryPlayerId,
                    }))
                }}
                handleRetiredHurt={() => setShowRretiredHurt(true)}
                overBalls={overBallByBallDisplay}
                overHistory={overHistory}
                currentOver={currentOver}
                players={players}
                showPaneltyRuns={setIsPaneltyPopup}
                target={target}
                partnerships={[...(partnershipHistory?.slice(0, -1) || []), currentPartnership]}
                anyPopup={props.statusPopup || inningsChangePopup || extrasType || showChangeOverModal || inningsChangePopup || showWicketModal || showUpdateInnings
                    || superOverModal || showRretiredHurt || isPaneltyPopup
                    || props.isDataLoading || isCommentaryBallLoading || selectMissingPlayer
                    || undoInningsPopup || completeMatchModal || winnerAnnouncement || isChangeBowler.isChangePopup || (changePlayerList ? true : false)}
                handleWheelShowToggle={handleWheelShowToggle}
                handleRemainingBallsShowToggle={handleRemainingBallsShowToggle}
                isRemainingBallsShow={isRemainingBallsShow}
                isWheelShow={isWheelShow}
                showWicketModal={showWicketModal}
                showChangeOverModal={showChangeOverModal && !changePlayerList}
                // wicket control
                // toggle={() => {
                //     setExtrasType(undefined)
                // }}
                // onSubmit={handleWicket}
                // bowlingTeam={players[BOWLING_TEAM]}
                // bowlingTeamDetails={teams[BOWLING_TEAM]}
                //Wicket Modal
                extraType={extrasType}
                {...(showWicketModal && {
                    isOpen: showWicketModal,
                    toggle: () => {
                        setShowWicketModal(undefined);
                        setExtrasType(undefined);
                    },
                    onSubmit: handleWicket,
                    bowlingTeam: players[BOWLING_TEAM],
                    bowlingTeamDetails: teams[BOWLING_TEAM],
                })}
                {...(extrasType && {
                    extrasTypeIsOpen: extrasType,
                    extrasTypeToggle: () => {
                        setExtrasType(undefined)
                    },
                    updateExtrasExtrasType: onExtrasChange
                })}
                // RetiredHurt
                // revertModal
                // {...(completeMatchModal && {
                //     revertModalisOpen:completeMatchModal,
                //     revertModaltoggle:() => { setCompleteMatchModal(undefined) },
                //     revertModalonNoClick:() => { setCompleteMatchModal(undefined) },
                //     revertModalonYesClick:() => completeMatch()
                // })}
                // RetiredHurt
                {...(showRretiredHurt && {
                    retiredHurtisOpen: showRretiredHurt,
                    retiredHurttoggle: () => setShowRretiredHurt(false),
                    retiredHurtonsubmit: onRetiredHurtClick,
                    retiringHurtPartnership: retiringHurtPartnership,
                    onPitchplayers: onPitchPlayers,
                    retiredHurtplayerList: players[BATTING_TEAM]?.filter((player) => (player.isPlay === null && player.isBatterOut !== true)),
                    allBattingPlayers: players[BATTING_TEAM]
                })}

                // change Innings
                {...(inningsChangePopup && {
                    inningsChangeisOpen: inningsChangePopup,
                    inningsChangetoggle: () => { setShowInningsChangePopup(undefined) },
                    inningsChangeNoClick: () => { setShowInningsChangePopup(undefined) },
                    inningsChangeYesClick: () => onInningsChange()
                })}

                // PenaltyModal
                {...(isPaneltyPopup && {
                    PenaltyToggle: () => { setIsPaneltyPopup(null) },
                    PenaltyIsOpen: true,
                    PenaltySelectedPenalty: (selectedPenalty) => {
                        updatePanelty(selectedPenalty)
                        setIsPaneltyPopup(null)
                    }
                })}


                {...((showChangeOverModal && !changePlayerList) && {
                    isOpen: { showChangeOverModal },
                    toggle: () => { setShowChangeOverModal(undefined); },
                    onNoClick: () => { setShowChangeOverModal(undefined); },
                    onYesClick: () => {
                        setIsBowlerrChange(true)
                        setShowChangeOverModal(undefined);
                        setChangeOverOnPopupClick(true)
                    },
                    overBalls: overBallByBallDisplay,
                    currentOver: currentOver,
                    battingTeam: teams?.[BATTING_TEAM] || {},
                    bowlerName: getPlayerNameById(players, currentOver?.bowlerId, false),
                    onPitchPlayers: onPitchPlayers,
                })}
                //Select Player Modal
                {...!(isCommentaryBallLoading || inningsChangePopup || superOverModal || showRretiredHurt || isPaneltyPopup || props.isDataLoading ||
                    winnerAnnouncement || showUpdateInnings || completeMatchModal || superOverModal || showCricketFieldModal) && !!changePlayerList &&
                {
                    isOpen: changePlayerList ? true : false,
                    showPlayerModal: true,
                    toggle: isWicketChange ? false : () => {
                        setChangePlayerList(undefined)
                        setIsSwapPlayer(undefined)
                        setOverPopUpForBowler(undefined)
                        setIsChangeBowler({ isChange: null, isChangePopup: null, popupOption: null })
                    },
                    overPopUpForBowler: overPopUpForBowler,
                    isBowler: (isChangeBowler.isChange || isBowlerrChange) ? true : false,
                    playerList: () => {
                        return changePlayerList?.filter(
                            (item) => item.currentInnings === commentaryDetails.currentInnings
                        );
                    },
                    selectPlayer: (newPlayerId) => {
                        if (isSwapPlayer) { setOverPopUpForBowler(undefined); setIsBowlerrChange(undefined); swapPlayer(newPlayerId) }
                        else if (isChangeBowler.isChange) { setOverPopUpForBowler(undefined); setIsBowlerrChange(undefined); onBowlerChange(newPlayerId) }
                        else {
                            setOverPopUpForBowler(undefined)
                            setIsBowlerrChange(undefined)
                            onPlayerChange(newPlayerId)
                        }
                    }
                }
                }

                isSelectPlayerModalOpen={!(isCommentaryBallLoading || inningsChangePopup || superOverModal || showRretiredHurt || isPaneltyPopup || props.isDataLoading ||
                    winnerAnnouncement || showUpdateInnings || completeMatchModal || superOverModal || showCricketFieldModal) && !!changePlayerList}
                selectPlayerModalProps={{
                    isOpen: !!changePlayerList,
                    toggle: isWicketChange ? false : () => {
                        setChangePlayerList(undefined);
                        setIsSwapPlayer(undefined);
                        setOverPopUpForBowler(undefined);
                        setIsChangeBowler({ isChange: null, isChangePopup: null, popupOption: null });
                    },
                    overPopUpForBowler,
                    isBowler: isChangeBowler.isChange || isBowlerrChange,
                    playerList: changePlayerList,
                    selectPlayer: (newPlayerId) => {
                        setOverPopUpForBowler(undefined);
                        setIsBowlerrChange(undefined);
                        if (isSwapPlayer) {
                            swapPlayer(newPlayerId);
                        } else if (isChangeBowler.isChange) {
                            onBowlerChange(newPlayerId);
                        } else {
                            onPlayerChange(newPlayerId);
                        }
                    }
                }}
                // wheel
                {...(showCricketFieldModal && {
                    cricketFieldData: cricketFieldData,
                    shotTypes: propsData?.commentaryData?.shotTypes,
                    isShotType: isShotType,
                    handleShotTypeToggle: handleShotTypeToggle,
                    cricketFieldIsOpen: true,
                    cricketFieldToggle: () => {
                        setShowCricketFieldModal(undefined);
                        setIsWheelShowComplete(true);
                    }
                })}

                // undo
                {...(undoOverPopup && {
                    undoOverPopupIsOpen: true,
                    undoOverPopupToggle: () => {
                        setUndoOverPopup(undefined)
                    },
                    onChangebowlerClick: () => {
                        setUndoOverPopup(undefined)
                        setIsChangeBowler({ isChange: true, isChangePopup: null, popupOption: SWITCH_BOWLER })
                        changePlayer(CURRENT_BOWLER)
                    },
                    onLastOverClick: () => {
                        setUndoOverPopup(undefined)
                        updateAfterOverUndo()
                    }
                })}
                // undo innings
                {...(undoInningsPopup && {
                    undoInningsPopupIsOpen: undoInningsPopup,
                    undoInningsPopupToggle: () => {
                        setUndoInningsPopup(undefined)
                    },
                    onLastInnigsClick: () => { },
                    onPlayerSelectionClick: { onUndoPlayerSelection }
                })}

                // complete Match Modal
                {...(completeMatchModal && {
                    completeMatchisOpen: completeMatchModal,
                    completeMatchtoggle: () => { setCompleteMatchModal(undefined) },
                    completeMatchNoClick: () => { setCompleteMatchModal(undefined) },
                    completeMatchYesClick: () => completeMatch()
                })}

                // Winner
                {...(winnerAnnouncement && {
                    winnerAnnouncementisOpen: winnerAnnouncement,
                    winnerAnnouncement: winnerAnnouncement,
                    onExitClick: () => {
                        setWinnerAnnouncement(undefined)
                        navigate("/commentary")
                        localStorage.setItem("superOverText", JSON.stringify(false));
                    }
                })}
            />
            : <CommentaryScreenNew
                refId={props.refId}
                currentInnings={teams && teams[BATTING_TEAM]?.teamTrialRuns}
                commentaryId={commentaryDetails?.commentaryId}
                teamDetails={teams}
                onPitchPlayers={onPitchPlayers}
                _onPitchPlayers={_onPitchPlayers}
                updateRuns={updateRuns}
                changePlayer={(type) => {
                    setIsSwapPlayer(true)
                    changePlayer(type)
                }}
                changeOver={() => { setShowChangeOverModal(true); }}
                updateExtras={(extraType) => {
                    setExtrasType(extraType)
                }}
                onWicketClick={() => { setShowWicketModal(true) }}
                changeStrike={changeOnStrikePlayer}
                endInnings={() => setShowInningsChangePopup(true)}
                onUndoClick={handleUndoClick}
                isLoading={isCommentaryBallLoading}
                changeBowler={() => {
                    setIsChangeBowler({ isChange: null, isChangePopup: true, popupOption: null })
                }}
                updateDisplayStatus={(displayStatus) => {
                    setBallStatus("ballstart");
                    dispatch(updateCommentaryBallStatus({
                        "commentaryId": commentaryDetails.commentaryId,
                        "displayStatus": displayStatus,
                        "commentaryPlayerId": onPitchPlayers[ON_STRIKE].commentaryPlayerId,
                    }))
                }}
                handleRetiredHurt={() => setShowRretiredHurt(true)}
                overBalls={overBallByBallDisplay}
                overHistory={overHistory}
                currentOver={currentOver}
                players={players}
                showPaneltyRuns={setIsPaneltyPopup}
                target={target}
                partnerships={[...(partnershipHistory?.slice(0, -1) || []), currentPartnership]}
                anyPopup={props.statusPopup || inningsChangePopup || extrasType || showChangeOverModal || inningsChangePopup || showWicketModal || showUpdateInnings
                    || superOverModal || showRretiredHurt || isPaneltyPopup
                    || props.isDataLoading || isCommentaryBallLoading || selectMissingPlayer
                    || undoInningsPopup || completeMatchModal || winnerAnnouncement || isChangeBowler.isChangePopup || (changePlayerList ? true : false)}
                handleWheelShowToggle={handleWheelShowToggle}
                handleRemainingBallsShowToggle={handleRemainingBallsShowToggle}
                isRemainingBallsShow={isRemainingBallsShow}
                isWheelShow={isWheelShow}
                isPredict={props?.isPredict}
                isPredictToggle={props?.isPredictToggle}
                setIsPredictToggle={props?.setIsPredictToggle}
                allteams={allInningaTeams}
                fetchData={props.fetchData}
                isSaving={isSaving}
                isAnyPopupOpen={isAnyPopupOpen}
                overTypeOption={overTypeOptions}
                overTypeValue={currentOver.overType || selectedOverType?.value}
                onOverTypeChange={handleOverTypeChange}
                handleDefaultOverSwitch={handleDefaultOverSwitch}
                isDefaultOverType={isDetaultOverType}
                bowlingTypes={props.data.commentaryData?.bowlingStyles}
                onBowlingTypeChange={onBowlingTypeChange}
                toggleUndoInnings={() => setUndoInningsPopup(!undoInningsPopup)}
                showInningsButton={showInningsButton}
            />}
        {!props?.isNewUi && !(isCommentaryBallLoading || inningsChangePopup || superOverModal || showRretiredHurt || isPaneltyPopup || props.isDataLoading ||
            winnerAnnouncement || showUpdateInnings || completeMatchModal || superOverModal || showCricketFieldModal) &&
            <SelectPlayerModal isOpen={changePlayerList ? true : false}
                toggle={isWicketChange ? false : () => {
                    setChangePlayerList(undefined)
                    setIsSwapPlayer(undefined)
                    setOverPopUpForBowler(undefined)
                    setIsChangeBowler({ isChange: null, isChangePopup: null, popupOption: null })
                }}
                overPopUpForBowler={overPopUpForBowler}
                isBowler={(isChangeBowler.isChange || isBowlerrChange) ? true : false}
                // playerList={changePlayerList}
                playerList={changePlayerList?.filter(
                    (item) => item.currentInnings === commentaryDetails.currentInnings
                )}
                selectPlayer={(newPlayerId, overType) => {
                    setOverPopUpForBowler(undefined)
                    setIsBowlerrChange(undefined);
                    if (isSwapPlayer) { swapPlayer(newPlayerId) }
                    else if (isChangeBowler.isChange) { onBowlerChange(newPlayerId) }
                    else {
                        onPlayerChange(newPlayerId, overType)
                    }
                }}
                isOverChangeNonDefault={!isDetaultOverType}
                overTypeOption={overTypeOptions}
                overType={selectedOverType}
            />}
        {(!props?.isNewUi && extrasType) && < ExtrasModal
            isOpen={true}
            toggle={() => { setExtrasType(undefined) }}
            extraType={extrasType}
            updateExtras={onExtrasChange} />}
        {(!props?.isNewUi && showChangeOverModal && !changePlayerList && !selectMissingPlayer && !showWicketModal) && <ChangeOverModal
            isOpen={showChangeOverModal}
            toggle={() => { setShowChangeOverModal(undefined); }}
            onNoClick={() => { setShowChangeOverModal(undefined); }}
            onYesClick={() => {
                setIsBowlerrChange(true)
                setShowChangeOverModal(undefined);
                setChangeOverOnPopupClick(true)
            }}
            overBalls={overBallByBallDisplay}
            currentOver={currentOver}
            battingTeam={teams?.[BATTING_TEAM] || {}}
            bowlerName={getPlayerNameById(players, currentOver?.bowlerId, false)}
            onPitchPlayers={onPitchPlayers}
        />}
        {(!props?.isNewUi && inningsChangePopup) && <ChangeInningsModal
            isOpen={inningsChangePopup}
            toggle={() => { setShowInningsChangePopup(undefined); /* setInningsChangeClosed(true); */ }}
            onNoClick={() => { setShowInningsChangePopup(undefined); /* setInningsChangeClosed(true); */ }}
            onYesClick={() => {
                // const isWicketBall = currentBall?.ballIsWicket;
                // const isLastBall = (currentOver?.ballCount) == matchTypeDetails?.ballsPerOver;
                // const syncOnPitchPlayers = isEmpty(_onPitchPlayers) ? onPitchPlayers : _onPitchPlayers;
                // const currentBowler = syncOnPitchPlayers?.[CURRENT_BOWLER]
                // const bowlerOver = currentBowler && Math.ceil(+currentBowler?.bowlerOver || 0);
                // if (isWicketBall && isLastBall && currentBowler && bowlerOver) {
                //     setChangeOverOnPopupClick(true);
                //     onInningsChange();
                // } else {
                    onInningsChange();
                // }
            }}
        />}
        {(!props?.isNewUi && showWicketModal) &&
            <WicketModal
                isOpen={showWicketModal}
                toggle={() => {
                    setShowWicketModal(undefined)
                    setExtrasType(undefined)
                }}
                onSubmit={handleWicket}
                bowlingTeam={players[BOWLING_TEAM]}
                bowlingTeamDetails={teams[BOWLING_TEAM]}
                onPitchPlayers={onPitchPlayers}
                extraType={extrasType}
            />}
        {showUpdateInnings && <UpdateInningsModal
            isOpen={showUpdateInnings}
            toggle={() => { setShowUpdateInnings(undefined) }}
            onsubmit={handleInningsUpdate}
            currentInningTeams={propsData.commentaryData?.commentaryTeams?.filter(team => team.currentInnings === (commentaryDetails.currentInnings + 1))}
        />}
        {(!props?.isNewUi && undoInningsPopup) && <UndoInnnigsModal isOpen={undoInningsPopup}
            toggle={() => { setUndoInningsPopup(undefined) }}
            onLastInningsClick={onUndoLastInnings}
            onPlayerSelectionClick={onUndoPlayerSelection}
        />}
        {(!props?.isNewUi && completeMatchModal) && <CompleteCurrentMatchModal
            isOpen={completeMatchModal}
            toggle={() => { setCompleteMatchModal(undefined) }}
            onNoClick={() => { setCompleteMatchModal(undefined) }}
            onYesClick={() => completeMatch()}
        />}
        {(!props?.isNewUi && winnerAnnouncement) && <WinnerModal
            isOpen={winnerAnnouncement ? true : false}
            winnerAnnouncement={winnerAnnouncement}
            onExitClick={() => {
                setWinnerAnnouncement(undefined)
                navigate("/commentary")
                localStorage.setItem("superOverText", JSON.stringify(false));
            }}
        />}
        {isChangeBowler.isChangePopup && !(completeMatchModal) && <ChangeBowlerModal
            toggle={() => { setIsChangeBowler({ isChange: null, isChangePopup: null, popupOption: null }) }}
            onBowlerChange={(selectedOption) => {
                setIsChangeBowler({ isChange: true, isChangePopup: null, popupOption: selectedOption })
                changePlayer(CURRENT_BOWLER)
            }}
        />}
        {(!props?.isNewUi && undoOverPopup) && <UndoOverModal
            isOpen={true}
            toggle={() => { setUndoOverPopup(undefined) }}
            onChangebowlerClick={() => {
                setUndoOverPopup(undefined)
                setIsChangeBowler({ isChange: true, isChangePopup: null, popupOption: SWITCH_BOWLER })
                changePlayer(CURRENT_BOWLER)
            }}
            onLastOverClick={() => {
                setUndoOverPopup(undefined)
                updateAfterOverUndo()
            }}
        />}
        {selectMissingPlayer && !(changePlayerList || superOverModal || winnerAnnouncement || completeMatchModal) &&
            <OnPitchPlayerModal
                onPitchPlayers={onPitchPlayers}
                players={players}
                updatePlayerOnParent={handleMissingPlayerChange}
                toggle={() => { setIsBowlerrChange(undefined); setSelectMissingPlayer(false) }}
            />
        }
        {undoErrorModal && <UndoErrorModal
            toggle={() => { setUndoErrorModal(null); setIsSaving(false); }}
            undoError={undoErrorModal}
        />}
        {(!props?.isNewUi && isPaneltyPopup) && <PenaltyModal
            toggle={() => { setIsPaneltyPopup(null) }}
            isOpen={true}
            selectedPenalty={(selectedPenalty) => {
                updatePanelty(selectedPenalty)
                setIsPaneltyPopup(null)
            }}
        />}
        {(!props?.isNewUi && showRretiredHurt) && <RetiredHurtModal
            toggle={() => setShowRretiredHurt(false)}
            onsubmit={onRetiredHurtClick}
            retiringHurtPartnership={retiringHurtPartnership}
            onPitchplayers={onPitchPlayers}
            playerList={players[BATTING_TEAM]?.filter((player) => (player.isPlay === null && player.isBatterOut !== true))}
            allBattingPlayers={players[BATTING_TEAM]}
        />}
        {superOverModal ?
            <SuperOverModal
                toggle={() => {
                    setSuperOverModal(false)
                }}
                onSuperOverClick={handleSuperOver}
                onResultClick={() => {
                    setSuperOverModal(false)
                    checkWinner()
                }}
                currentInningTeams={Object.values(teams || {})}
            />
            : null}
        {retryModel && <RetryModel errorMsg={retryModel} />}
        {(!props?.isNewUi && showCricketFieldModal) && (
            <CricketFieldModal
                cricketFieldData={cricketFieldData}
                shotTypes={propsData?.commentaryData?.shotTypes}
                isShotType={isShotType}
                handleShotTypeToggle={handleShotTypeToggle}
                isOpen={showCricketFieldModal}
                toggle={() => {
                    setShowCricketFieldModal(undefined);
                    setIsWheelShowComplete(true);
                }}
            />
        )}
    </>
}

export default CommentaryNew